import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import "./App.css";
import ProventosTemplate from "./ProventosTemplate";
import ImoveisTemplate from "./ImoveisTemplate";
import ModalGastosViagem from "./ModalGastosViagem";
import { NovaTransacaoFixedIncomeModal, GerenciarTiposFixedIncomeModal } from "./FixedIncomeModals";
import { FixedIncomeTableRows, useFixedIncomeActions } from "./FixedIncomeTable";
import { NovaTransacaoCompraDolarModal, CompraDolarTableRows, useCompraDolarActions } from "./CompraDolarComponents";
import { GerenciarCadastroB3Modal } from "./GerenciarCadastroB3Modal";
import { GerenciarCadastroExteriorModal } from "./GerenciarCadastroExteriorModal";
import { BotaoCompraParcelada, SecaoComprasParceladas } from "./ComprasParceladasComponents";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const [transacoes, setTransacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTransacoes, setFilteredTransacoes] = useState([]);
  const [filteredFixedIncomeTransacoes, setFilteredFixedIncomeTransacoes] = useState([]);
  const [filteredReservaValorTransacoes, setFilteredReservaValorTransacoes] = useState([]);
  const [estatisticas, setEstatisticas] = useState(null);
  const [showManageCompanies, setShowManageCompanies] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(() => {
    // Ler do localStorage na inicialização para evitar sobrescrever
    return localStorage.getItem('currentTemplate') || 'B3';
  });
  const [tipoInvestimento, setTipoInvestimento] = useState(() => {
    return localStorage.getItem('tipoInvestimento') || 'Poupança';
  });
  const [titulos, setTitulos] = useState([]);
  const [showNovaReceita, setShowNovaReceita] = useState(false);
  const [showNovaDespesa, setShowNovaDespesa] = useState(false);
  const [tabelaExpandida, setTabelaExpandida] = useState(true);
  const [tabelaDespesasMensaisExpandida, setTabelaDespesasMensaisExpandida] = useState(true);
  const [showNovoGastoMensal, setShowNovoGastoMensal] = useState(false);
  const [despesasMensais, setDespesasMensais] = useState([]);
  
  // Estados para Proventos
  const [proventos, setProventos] = useState([]);
  const [origensProventos, setOrigensProventos] = useState([]);
  const [showNovoProvento, setShowNovoProvento] = useState(false);
  const [showNovaOrigem, setShowNovaOrigem] = useState(false);
  const [editingProvento, setEditingProvento] = useState(null);
  const [estatisticasProventos, setEstatisticasProventos] = useState(null);
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear());
  const [filtroMes, setFiltroMes] = useState(new Date().getMonth() + 1);
  
  // Estados para Reserva de Valor
  const [reservaValorTransacoes, setReservaValorTransacoes] = useState([]);
  const [reservaValorCadastros, setReservaValorCadastros] = useState([]);
  const [reservaValorStats, setReservaValorStats] = useState(null);
  const [showNovaTransacaoReserva, setShowNovaTransacaoReserva] = useState(false);
  const [editingReservaTransacao, setEditingReservaTransacao] = useState(null);
  const [showGerenciarReservas, setShowGerenciarReservas] = useState(false);

  // Estados para Fixed Income (Exterior)
  const [modalidadeExterior, setModalidadeExterior] = useState('Wall Street');
  const [fixedIncomeTransacoes, setFixedIncomeTransacoes] = useState([]);
  const [fixedIncomeTipos, setFixedIncomeTipos] = useState([]);
  const [fixedIncomeStats, setFixedIncomeStats] = useState(null);
  const [showNovaTransacaoFixedIncome, setShowNovaTransacaoFixedIncome] = useState(false);
  const [editingFixedIncome, setEditingFixedIncome] = useState(null);
  const [showGerenciarTiposFixedIncome, setShowGerenciarTiposFixedIncome] = useState(false);

  // Estados para Compra Dólar (Exterior)
  const [compraDolarTransacoes, setCompraDolarTransacoes] = useState([]);
  const [compraDolarStats, setCompraDolarStats] = useState(null);
  const [showNovaTransacaoCompraDolar, setShowNovaTransacaoCompraDolar] = useState(false);
  const [editingCompraDolar, setEditingCompraDolar] = useState(null);

  // Estado para modal de seleção de templates
  const [showTemplateModal, setShowTemplateModal] = useState(false);

  // Estado para modal de gerenciar cadastro B3
  const [showGerenciarCadastroB3, setShowGerenciarCadastroB3] = useState(false);

  // Estado para modal de gerenciar cadastro Exterior
  const [showGerenciarCadastroExterior, setShowGerenciarCadastroExterior] = useState(false);

  // Estados para Imóveis
  const [imoveis, setImoveis] = useState([]);
  const [imoveisStats, setImoveisStats] = useState(null);
  const [showNovoImovel, setShowNovoImovel] = useState(false);
  const [showVendaImovel, setShowVendaImovel] = useState(false);
  const [editingImovel, setEditingImovel] = useState(null);
  const [tabelaImoveisExpandida, setTabelaImoveisExpandida] = useState(true);

  // Estados para Modal de Gastos de Viagem
  const [showGastosViagem, setShowGastosViagem] = useState(false);
  const [selectedViagemGastos, setSelectedViagemGastos] = useState(null);

  // Bloquear scroll quando modal aberto
  useEffect(() => {
    if (showTemplateModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showTemplateModal]);

  useEffect(() => {
    carregarDados();
  }, [currentTemplate, tipoInvestimento]);

  useEffect(() => {
    // Salvar template atual no localStorage
    localStorage.setItem('currentTemplate', currentTemplate);
  }, [currentTemplate]);

  useEffect(() => {
    // Verificar se deve abrir o modal de investimentos ao carregar
    const shouldOpenModal = localStorage.getItem('openInvestmentModal');
    if (shouldOpenModal === 'true') {
      setShowTemplateModal(true);
      localStorage.removeItem('openInvestmentModal'); // Limpar flag após usar
    }
  }, []);

  useEffect(() => {
    // Salvar tipo de investimento no localStorage
    localStorage.setItem('tipoInvestimento', tipoInvestimento);
  }, [tipoInvestimento]);

  useEffect(() => {
    // Carregar configurações do localStorage na inicialização
    const savedTemplate = localStorage.getItem('currentTemplate');
    const savedTipoInvestimento = localStorage.getItem('tipoInvestimento');
    
    if (savedTemplate && savedTemplate !== currentTemplate) {
      setCurrentTemplate(savedTemplate);
    }
    if (savedTipoInvestimento && savedTipoInvestimento !== tipoInvestimento) {
      setTipoInvestimento(savedTipoInvestimento);
    }
  }, []);

  useEffect(() => {
    // Filtrar transações conforme busca
    if (currentTemplate === 'Finanças Pessoais') {
      // Para Finanças Pessoais, não filtrar (já é um objeto com receitas e despesas)
      setFilteredTransacoes(transacoes);
    } else if (searchTerm && Array.isArray(transacoes)) {
      const tipoInvestimento = localStorage.getItem('tipoInvestimento');
      
      // Filtro específico para Poupança
      if (currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Poupança') {
        const filtered = transacoes.filter(t => 
          t.banco?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.tipo_transacao?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.data?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTransacoes(filtered);
      } else if (currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Tesouro Direto') {
        // Filtro específico para Tesouro Direto
        const filtered = transacoes.filter(t => 
          t.tipo_titulo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.data?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTransacoes(filtered);
      } else if (currentTemplate === 'Viagem') {
        // Filtro específico para Viagem
        const filtered = transacoes.filter(t => 
          t.nome_viagem?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.tipo_transacao?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.data?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTransacoes(filtered);
      } else {
        // Filtro padrão para outros templates
        const filtered = transacoes.filter(t => 
          t.empresa?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.codigo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.setor?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.tipo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.categoria?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredTransacoes(filtered);
      }
    } else {
      setFilteredTransacoes(transacoes);
    }
  }, [searchTerm, transacoes, currentTemplate]);

  // Filtro para Fixed Income
  useEffect(() => {
    if (searchTerm && Array.isArray(fixedIncomeTransacoes)) {
      const filtered = fixedIncomeTransacoes.filter(t => 
        t.tipo_investimento?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.data_aplicacao?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.status?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.dias_vencimento?.toString().includes(searchTerm)
      );
      setFilteredFixedIncomeTransacoes(filtered);
    } else {
      setFilteredFixedIncomeTransacoes(fixedIncomeTransacoes);
    }
  }, [searchTerm, fixedIncomeTransacoes]);

  // Filtro para Reserva de Valor
  useEffect(() => {
    if (searchTerm && Array.isArray(reservaValorTransacoes)) {
      const filtered = reservaValorTransacoes.filter(t => 
        t.tipo_reserva?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.data?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.acao?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredReservaValorTransacoes(filtered);
    } else {
      setFilteredReservaValorTransacoes(reservaValorTransacoes);
    }
  }, [searchTerm, reservaValorTransacoes]);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const carregarTitulos = async () => {
    if (tipoInvestimento !== 'Tesouro Direto') return;
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/titulos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTitulos(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar títulos:', error);
      setTitulos([]);
    }
  };

  useEffect(() => {
    if (tipoInvestimento === 'Tesouro Direto') {
      carregarTitulos();
    }
  }, [tipoInvestimento]);

  useEffect(() => {
    if (editingReservaTransacao) {
      setShowNovaTransacaoReserva(true);
    }
  }, [editingReservaTransacao]);

  useEffect(() => {
    if (editingFixedIncome) {
      setShowNovaTransacaoFixedIncome(true);
    }
  }, [editingFixedIncome]);

  useEffect(() => {
    if (editingCompraDolar) {
      setShowNovaTransacaoCompraDolar(true);
    }
  }, [editingCompraDolar]);

  useEffect(() => {
    // Recarregar quando modalidade Exterior muda
    if (currentTemplate === 'Wall Street') {
      carregarDados();
    }
  }, [modalidadeExterior]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      // Resetar transações para evitar erro "map is not a function"
      setTransacoes([]);
      
      if (currentTemplate === 'BR Renda Fixa') {
        if (tipoInvestimento === 'Reserva de Valor') {
          // Carregar dados de Reserva de Valor
          const [transacoesRes, cadastrosRes, statsRes] = await Promise.all([
            axios.get(`${API}/reserva-valor/transacoes`, getAuthHeaders()),
            axios.get(`${API}/reserva-valor/cadastros`, getAuthHeaders()),
            axios.get(`${API}/reserva-valor/estatisticas`, getAuthHeaders())
          ]);
          
          setReservaValorTransacoes(transacoesRes.data);
          setReservaValorCadastros(cadastrosRes.data);
          setReservaValorStats(statsRes.data);
          
          // Inicializar tipos padrão se necessário
          if (cadastrosRes.data.length === 0) {
            await axios.post(`${API}/reserva-valor/inicializar`, {}, getAuthHeaders());
            const novoCadastrosRes = await axios.get(`${API}/reserva-valor/cadastros`, getAuthHeaders());
            setReservaValorCadastros(novoCadastrosRes.data);
          }
        } else {
          const [transacoesRes, statsRes] = await Promise.all([
            axios.get(`${API}/renda-fixa/${tipoInvestimento}`, getAuthHeaders()),
            axios.get(`${API}/renda-fixa/estatisticas/${tipoInvestimento}`, getAuthHeaders())
          ]);
          
          setTransacoes(transacoesRes.data);
          setEstatisticas(statsRes.data);
        }
      } else if (currentTemplate === 'Viagem') {
        const [transacoesRes, statsRes] = await Promise.all([
          axios.get(`${API}/viagens/transacoes`, getAuthHeaders()),
          axios.get(`${API}/viagens/estatisticas`, getAuthHeaders())
        ]);
        
        setTransacoes(transacoesRes.data);
        setEstatisticas(statsRes.data);
      } else if (currentTemplate === 'Finanças Pessoais') {
        const [receitasRes, despesasRes, despesasMensaisRes, statsRes] = await Promise.all([
          axios.get(`${API}/financas/receitas`, getAuthHeaders()),
          axios.get(`${API}/financas/despesas`, getAuthHeaders()),
          axios.get(`${API}/financas/despesas-mensais`, getAuthHeaders()),
          axios.get(`${API}/financas/estatisticas`, getAuthHeaders())
        ]);
        
        setTransacoes({ receitas: receitasRes.data, despesas: despesasRes.data });
        setDespesasMensais(despesasMensaisRes.data);
        setEstatisticas(statsRes.data);
      } else if (currentTemplate === 'Proventos') {
        const [proventosRes, origensRes, statsRes] = await Promise.all([
          axios.get(`${API}/proventos`, getAuthHeaders()),
          axios.get(`${API}/origens-proventos`, getAuthHeaders()),
          axios.get(`${API}/proventos/estatisticas`, getAuthHeaders())
        ]);
        
        setProventos(proventosRes.data);
        setOrigensProventos(origensRes.data);
        setEstatisticasProventos(statsRes.data);
      } else if (currentTemplate === 'Imóveis') {
        const [imoveisRes, statsRes] = await Promise.all([
          axios.get(`${API}/imoveis`, getAuthHeaders()),
          axios.get(`${API}/imoveis/estatisticas`, getAuthHeaders())
        ]);
        
        setImoveis(imoveisRes.data);
        setImoveisStats(statsRes.data);
      } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income') {
        // Carregar dados de Fixed Income
        const [transacoesRes, tiposRes, statsRes] = await Promise.all([
          axios.get(`${API}/fixed-income/transacoes`, getAuthHeaders()),
          axios.get(`${API}/fixed-income/tipos`, getAuthHeaders()),
          axios.get(`${API}/fixed-income/estatisticas`, getAuthHeaders())
        ]);
        
        setFixedIncomeTransacoes(transacoesRes.data);
        setFixedIncomeTipos(tiposRes.data);
        setFixedIncomeStats(statsRes.data);
      } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar') {
        // Carregar dados de Compra Dólar
        const [transacoesRes, statsRes] = await Promise.all([
          axios.get(`${API}/compra-dolar/transacoes`, getAuthHeaders()),
          axios.get(`${API}/compra-dolar/estatisticas`, getAuthHeaders())
        ]);
        
        setCompraDolarTransacoes(transacoesRes.data);
        setCompraDolarStats(statsRes.data);
      } else {
        const [transacoesRes, statsRes] = await Promise.all([
          axios.get(`${API}/transacoes/${currentTemplate}`, getAuthHeaders()),
          axios.get(`${API}/estatisticas/resumo/${currentTemplate}`, getAuthHeaders())
        ]);
        
        setTransacoes(transacoesRes.data);
        setEstatisticas(statsRes.data);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        handleLogout();
      } else {
        toast.error('Erro ao carregar dados');
      }
    } finally {
      setLoading(false);
    }
  };

  // Fixed Income Actions (após carregarDados para evitar erro de inicialização)
  const { handleConcluir: concluirFixedIncome, handleDelete: deleteFixedIncome } = useFixedIncomeActions(carregarDados);

  // Compra Dólar Actions
  const { handleDelete: deleteCompraDolar } = useCompraDolarActions(carregarDados);

  const handleLogout = () => {
    localStorage.removeItem('token');
    onLogout();
  };

  const excluirTransacao = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta transação?')) {
      try {
        await axios.delete(`${API}/transacoes/${id}`, getAuthHeaders());
        toast.success('Transação excluída com sucesso');
        carregarDados();
      } catch (error) {
        toast.error('Erro ao excluir transação');
      }
    }
  };

  const excluirRendaFixa = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta transação?')) {
      try {
        await axios.delete(`${API}/renda-fixa/${id}`, getAuthHeaders());
        toast.success('Transação excluída com sucesso');
        carregarDados();
      } catch (error) {
        toast.error('Erro ao excluir transação');
      }
    }
  };

  const excluirTransacaoViagem = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta transação?')) {
      try {
        await axios.delete(`${API}/viagens/transacoes/${id}`, getAuthHeaders());
        toast.success('Transação excluída com sucesso');
        carregarDados();
      } catch (error) {
        toast.error('Erro ao excluir transação');
      }
    }
  };

  const formatCurrency = (value, template = currentTemplate, modalidade = modalidadeExterior) => {
    if (template === 'Wall Street' && modalidade === 'Fixed Income') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    }
    if (template === 'Wall Street') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    }
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <button 
                onClick={() => navigate('/dashboard-geral')}
                className="w-16 h-16 flex items-center justify-center mr-3 hover:opacity-80 transition-opacity"
                title="Ir para Dashboard Geral"
              >
                <img src="/ap-logo.png" alt="AP Logo" className="w-full h-full object-contain" />
              </button>
              <button 
                onClick={() => {
                  console.log('Clicou em Finanças Pessoais');
                  setCurrentTemplate('Finanças Pessoais');
                }}
                className="text-sm text-gray-600 font-medium hover:text-indigo-600 transition-colors cursor-pointer"
              >
                Finanças Pessoais
              </button>
            </div>

            <div className="flex items-center gap-4">
              {/* Botão Investimentos - Desktop: ícone + texto / Mobile: apenas ícone */}
              <button
                onClick={() => setShowTemplateModal(true)}
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg"
                data-testid="investimentos-button"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="hidden md:inline font-medium">Investimentos</span>
              </button>

              {/* Botão Quero Economizar Agora com efeito pulse */}
              <button
                onClick={() => window.location.href = '/igreen'}
                className="flex flex-col items-center justify-center px-4 py-2 text-white rounded-lg transition-all shadow-md hover:shadow-lg animate-pulse-soft"
                data-testid="economizar-button"
                style={{ 
                  backgroundColor: '#22c55e',
                  minHeight: '48px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#16a34a'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#22c55e'}
              >
                <span className="font-semibold text-sm md:text-base leading-tight text-center">
                  Quero Economizar Agora
                </span>
                <span className="text-xs opacity-90 mt-0.5">
                  conta de energia
                </span>
              </button>
            
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                data-testid="logout-button"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Modal de Seleção de Templates */}
      {showTemplateModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowTemplateModal(false)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header do Modal */}
            <div className="p-6 border-b border-gray-200 flex justify-between items-center sticky top-0 bg-white z-10 rounded-t-2xl">
              <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                <svg className="w-7 h-7 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Selecione seu Investimento
              </h2>
              <button 
                onClick={() => setShowTemplateModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Botões dos Templates */}
            <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* B3 */}
              <button
                onClick={() => {
                  setCurrentTemplate('B3');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 ${
                  currentTemplate === 'B3'
                    ? 'border-blue-600 bg-blue-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-blue-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`text-4xl ${currentTemplate === 'B3' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    🇧🇷
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">B3</h3>
                    <p className="text-sm text-gray-600">Bolsa Brasileira</p>
                  </div>
                </div>
                {currentTemplate === 'B3' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>

              {/* Exterior */}
              <button
                onClick={() => {
                  setCurrentTemplate('Wall Street');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 ${
                  currentTemplate === 'Wall Street'
                    ? 'border-green-600 bg-green-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-green-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`text-4xl ${currentTemplate === 'Wall Street' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    🌍
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">Exterior</h3>
                    <p className="text-sm text-gray-600">Mercado Internacional</p>
                  </div>
                </div>
                {currentTemplate === 'Wall Street' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>

              {/* BR Renda Fixa */}
              <button
                onClick={() => {
                  setCurrentTemplate('BR Renda Fixa');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 ${
                  currentTemplate === 'BR Renda Fixa'
                    ? 'border-orange-600 bg-orange-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-orange-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`text-4xl ${currentTemplate === 'BR Renda Fixa' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    🏦
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">BR Renda Fixa</h3>
                    <p className="text-sm text-gray-600">Investimentos Fixos</p>
                  </div>
                </div>
                {currentTemplate === 'BR Renda Fixa' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>

              {/* Viagem */}
              <button
                onClick={() => {
                  setCurrentTemplate('Viagem');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 ${
                  currentTemplate === 'Viagem'
                    ? 'border-purple-600 bg-purple-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-purple-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`text-4xl ${currentTemplate === 'Viagem' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    ✈️
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">Viagem</h3>
                    <p className="text-sm text-gray-600">Planejamento de Viagens</p>
                  </div>
                </div>
                {currentTemplate === 'Viagem' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>

              {/* Proventos */}
              <button
                onClick={() => {
                  setCurrentTemplate('Proventos');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 sm:col-span-2 ${
                  currentTemplate === 'Proventos'
                    ? 'border-emerald-600 bg-emerald-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-emerald-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3 justify-center sm:justify-start">
                  <div className={`text-4xl ${currentTemplate === 'Proventos' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    💰
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">Proventos</h3>
                    <p className="text-sm text-gray-600">Dividendos e Rendimentos</p>
                  </div>
                </div>
                {currentTemplate === 'Proventos' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>

              {/* Imóveis */}
              <button
                onClick={() => {
                  setCurrentTemplate('Imóveis');
                  setShowTemplateModal(false);
                }}
                className={`group relative p-6 rounded-xl border-2 transition-all duration-200 sm:col-span-2 ${
                  currentTemplate === 'Imóveis'
                    ? 'border-amber-600 bg-amber-50 shadow-lg scale-105'
                    : 'border-gray-200 hover:border-amber-400 hover:shadow-md'
                }`}
              >
                <div className="flex items-center gap-3 justify-center sm:justify-start">
                  <div className={`text-4xl ${currentTemplate === 'Imóveis' ? 'scale-110' : 'group-hover:scale-110'} transition-transform`}>
                    🏠
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-bold text-gray-900">Imóveis</h3>
                    <p className="text-sm text-gray-600">Gestão de Propriedades</p>
                  </div>
                </div>
                {currentTemplate === 'Imóveis' && (
                  <div className="absolute top-2 right-2">
                    <svg className="w-5 h-5 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Estatísticas */}
        {currentTemplate !== 'Proventos' && currentTemplate === 'Viagem' && estatisticas && Array.isArray(estatisticas) && estatisticas.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {estatisticas.filter(v => v.status !== 'Concluída').map((viagem) => {
              const porcentagemOrcamento = viagem.orcamento > 0 ? (viagem.total_acumulado / viagem.orcamento) * 100 : 0;
              const porcentagemLimitada = Math.min(Math.max(porcentagemOrcamento, 0), 100);
              
              return (
                <div key={viagem.viagem_id} className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                  {/* Header - Nome e Percentual */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="p-3 rounded-full bg-purple-100">
                        <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <p className="font-semibold text-gray-900">{viagem.nome_viagem}</p>
                    </div>
                    <span className="text-green-500 font-medium text-sm">{porcentagemOrcamento.toFixed(1)}%</span>
                  </div>
                  
                  {/* Barra de Progresso */}
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
                    <div 
                      className="bg-green-500 h-2 rounded-full transition-all duration-300"
                      style={{ width: `${porcentagemLimitada}%` }}
                    ></div>
                  </div>
                  
                  {/* Valores */}
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Orçamento:</span>
                      <span className="font-semibold text-gray-900">{formatCurrency(viagem.orcamento)}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-500">Total Acumulado:</span>
                      <span className="font-semibold text-green-600">{formatCurrency(viagem.total_acumulado)}</span>
                    </div>
                  </div>

                  {/* Botão Gastos */}
                  <button
                    onClick={() => {
                      setSelectedViagemGastos(viagem);
                      setShowGastosViagem(true);
                    }}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                    data-testid="gastos-viagem-btn"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Gastos
                  </button>
                </div>
              );
            })}
          </div>
        ) : currentTemplate === 'Finanças Pessoais' && estatisticas ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-green-100">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Receitas</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(estatisticas.total_receitas)}</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-red-100">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Despesas</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(estatisticas.total_despesas)}</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className={`p-3 rounded-full ${estatisticas.margem_investimento >= 30 ? 'bg-green-100' : 'bg-blue-100'}`}>
                  {estatisticas.margem_investimento >= 30 ? (
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                    </svg>
                  )}
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Margem de Investimento</p>
                  <p className="text-2xl font-bold text-gray-900">{(estatisticas.margem_investimento || 0).toFixed(2)}%</p>
                </div>
              </div>
            </div>
          </div>
        ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor' && reservaValorStats ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* Total Investido em Ouro */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-yellow-100">
                  <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Total Investido em Ouro</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(reservaValorStats.total_ouro)}</p>
                </div>
              </div>
            </div>

            {/* Total Investido em Bitcoin */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-orange-100">
                  <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Total Investido em Bitcoin</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(reservaValorStats.total_bitcoin)}</p>
                </div>
              </div>
            </div>

            {/* Total Investido em Ethereum */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-blue-100">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Total Investido em Ethereum</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(reservaValorStats.total_ethereum)}</p>
                </div>
              </div>
            </div>
          </div>
        ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income' && fixedIncomeStats ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* Total Investido (em aberto) */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-blue-100">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Total Investido (em aberto)</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(fixedIncomeStats.total_investido_aberto)}</p>
                  <p className="text-xs text-gray-500 mt-1">Soma dos investimentos ainda em aberto.</p>
                </div>
              </div>
            </div>

            {/* Rendimentos Brutos (últimos 12 meses) */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-green-100">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Rendimentos Brutos (últimos 12 meses)</p>
                  <p className="text-2xl font-bold text-gray-900">{formatCurrency(fixedIncomeStats.rendimentos_12_meses)}</p>
                  <p className="text-xs text-gray-500 mt-1">Somatório dos ganhos de aplicações concluídas nos últimos 12 meses.</p>
                </div>
              </div>
            </div>

            {/* Investimentos em Aberto */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-purple-100">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Investimentos em Aberto</p>
                  <p className="text-2xl font-bold text-gray-900">{fixedIncomeStats.investimentos_abertos}</p>
                  <p className="text-xs text-gray-500 mt-1">Quantidade total de aplicações em aberto.</p>
                </div>
              </div>
            </div>
          </div>
        ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar' && compraDolarStats ? (
          <div className="grid grid-cols-1 gap-6 mb-8">
            {/* Dólares Possuídos */}
            <div className="bg-gradient-to-r from-green-50 to-green-100 p-8 rounded-2xl shadow-lg border border-green-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="p-4 rounded-full bg-green-500 shadow-md">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="ml-6">
                    <p className="text-lg font-semibold text-gray-700">Dólares Possuídos (US$)</p>
                    <p className="text-4xl font-bold text-green-700 mt-2">
                      {new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                      }).format(compraDolarStats.dolares_possuidos)}
                    </p>
                    <p className="text-sm text-gray-600 mt-2">
                      Total de dólares = (Compras) - (Vendas)
                    </p>
                  </div>
                </div>
                <div className="hidden md:block">
                  <div className="text-6xl opacity-20">💵</div>
                </div>
              </div>
            </div>
          </div>
        ) : currentTemplate !== 'Proventos' && currentTemplate !== 'Imóveis' && estatisticas && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-green-100">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">
                    {currentTemplate === 'BR Renda Fixa' ? 'Total Investido' : 'Total Compras'}
                  </p>
                  <p className="text-2xl font-bold text-gray-900">
                    {formatCurrency(currentTemplate === 'BR Renda Fixa' ? estatisticas.total_investido : estatisticas.total_compras)}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-blue-100">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">
                    {currentTemplate === 'BR Renda Fixa' ? 'Total Retirado' : 'Total Vendas'}
                  </p>
                  <p className="text-2xl font-bold text-gray-900">
                    {formatCurrency(currentTemplate === 'BR Renda Fixa' ? estatisticas.total_retirado : estatisticas.total_vendas)}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
              <div className="flex items-center">
                <div className="p-3 rounded-full bg-purple-100">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2H9a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-600">Transações</p>
                  <p className="text-2xl font-bold text-gray-900">{estatisticas.total_transacoes}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Controles */}
        {currentTemplate !== 'Proventos' && currentTemplate !== 'Imóveis' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            {currentTemplate !== 'Finanças Pessoais' && (
              <div className="flex-1 max-w-md flex gap-2">
                {!(currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar') && (
                  <input
                    type="text"
                    placeholder={currentTemplate === 'Viagem' ? 'Buscar viagem...' : 'Buscar por empresa, código, setor...'}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    data-testid="search-input"
                  />
                )}
                
                {currentTemplate === 'Wall Street' && (
                  <select
                    value={modalidadeExterior}
                    onChange={(e) => setModalidadeExterior(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    data-testid="modalidade-exterior-select"
                  >
                    <option value="Wall Street">Wall Street</option>
                    <option value="Fixed Income">Fixed Income</option>
                    <option value="Compra Dólar">Compra Dólar</option>
                  </select>
                )}

                {currentTemplate === 'BR Renda Fixa' && (
                  <select
                    value={tipoInvestimento}
                    onChange={(e) => setTipoInvestimento(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    data-testid="tipo-investimento-select"
                  >
                    <option value="Poupança">Poupança</option>
                    <option value="Tesouro Direto">Tesouro Direto</option>
                    <option value="Reserva de Valor">Reserva de Valor</option>
                  </select>
                )}
              </div>
            )}
            
            <div className={`flex gap-2 ${currentTemplate === 'Finanças Pessoais' ? 'w-full justify-center' : ''}`}>
              {!(currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar') && currentTemplate !== 'Finanças Pessoais' && (
                <button
                  onClick={() => {
                    if (currentTemplate === 'B3') {
                      setShowGerenciarCadastroB3(true);
                    } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Wall Street') {
                      setShowGerenciarCadastroExterior(true);
                    } else if (currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor') {
                      setShowGerenciarReservas(true);
                    } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income') {
                      setShowGerenciarTiposFixedIncome(true);
                    } else {
                      setShowManageCompanies(true);
                    }
                  }}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-200 flex items-center gap-2"
                  data-testid="manage-companies-button"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  {currentTemplate === 'B3' ? 'Gerenciar Cadastro' : (currentTemplate === 'Wall Street' && modalidadeExterior === 'Wall Street') ? 'Gerenciar Cadastro' : currentTemplate === 'Viagem' ? 'Gerenciar Viagem' : (currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor') ? 'Gerenciar Reservas de Valor' : (currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income') ? 'Gerenciar Tipos' : 'Gerenciar Cadastros'}
                </button>
              )}
              
              <button
                onClick={() => {
                  if (currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor') {
                    setShowNovaTransacaoReserva(true);
                  } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income') {
                    setShowNovaTransacaoFixedIncome(true);
                  } else if (currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar') {
                    setShowNovaTransacaoCompraDolar(true);
                  } else {
                    setShowAddForm(true);
                  }
                }}
                className={`px-6 py-2 bg-gradient-to-r ${
                  currentTemplate === 'Viagem' 
                    ? 'from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800'
                    : currentTemplate === 'Finanças Pessoais'
                    ? 'from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800'
                    : 'from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800'
                } text-white rounded-lg transition-all duration-200 flex items-center gap-2`}
                data-testid="add-transaction-button"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Nova Transação
              </button>
              
              {currentTemplate === 'Finanças Pessoais' && (
                <>
                  <button
                    onClick={() => setShowNovoGastoMensal(true)}
                    className="px-6 py-2 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white rounded-lg transition-all duration-200 flex items-center gap-2"
                    data-testid="add-gasto-mensal-button"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    Novo Gasto Mensal
                  </button>
                  
                  <BotaoCompraParcelada onSuccess={carregarDados} />
                </>
              )}
            </div>
          </div>
        </div>
        )}

        {/* Tabela de Transações */}
        {currentTemplate === 'Proventos' ? (
          <ProventosTemplate getAuthHeaders={getAuthHeaders} />
        ) : currentTemplate === 'Imóveis' ? (
          <ImoveisTemplate getAuthHeaders={getAuthHeaders} />
        ) : currentTemplate === 'Finanças Pessoais' ? (
          <>
            {/* Tabela Gestão Geral */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-8">
            {/* Header com botão expandir/recolher */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h3 className="text-lg font-bold text-gray-900">Gestão Geral</h3>
              <button
                onClick={() => setTabelaExpandida(!tabelaExpandida)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {tabelaExpandida ? (
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
              </button>
            </div>

            {/* Conteúdo da tabela */}
            {tabelaExpandida && (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoria/Subcategoria</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredTransacoes.receitas && filteredTransacoes.receitas.length > 0 && (
                      <>
                        <tr className="bg-green-50">
                          <td colSpan="5" className="px-6 py-2 text-sm font-bold text-green-800">RECEITAS</td>
                        </tr>
                        {filteredTransacoes.receitas.map((receita) => (
                          <tr key={receita.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{receita.origem}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">-</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{formatDate(receita.data)}</td>
                            <td className="px-6 py-4 text-sm font-bold text-green-600">{formatCurrency(receita.valor)}</td>
                            <td className="px-6 py-4 text-sm font-medium">
                              <div className="flex space-x-2">
                                <button
                                  onClick={() => setEditingTransaction(receita)}
                                  className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                                  title="Editar"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={async () => {
                                    if (window.confirm('Deseja excluir esta receita?')) {
                                      try {
                                        await axios.delete(`${API}/financas/receitas/${receita.id}`, getAuthHeaders());
                                        toast.success('Receita excluída');
                                        carregarDados();
                                      } catch (error) {
                                        toast.error('Erro ao excluir');
                                      }
                                    }
                                  }}
                                  className="text-red-600 hover:text-red-900 p-1 rounded"
                                  title="Excluir"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    
                    {filteredTransacoes.despesas && filteredTransacoes.despesas.length > 0 && (
                      <>
                        <tr className="bg-red-50">
                          <td colSpan="5" className="px-6 py-2 text-sm font-bold text-red-800">DESPESAS</td>
                        </tr>
                        {filteredTransacoes.despesas.map((despesa) => (
                          <tr key={despesa.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{despesa.categoria}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{despesa.subcategoria || '-'}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{formatDate(despesa.data)}</td>
                            <td className="px-6 py-4 text-sm font-bold text-red-600">{formatCurrency(despesa.valor)}</td>
                            <td className="px-6 py-4 text-sm font-medium">
                              <div className="flex space-x-2">
                                <button
                                  onClick={() => setEditingTransaction(despesa)}
                                  className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                                  title="Editar"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={async () => {
                                    if (window.confirm('Deseja excluir esta despesa?')) {
                                      try {
                                        await axios.delete(`${API}/financas/despesas/${despesa.id}`, getAuthHeaders());
                                        toast.success('Despesa excluída');
                                        carregarDados();
                                      } catch (error) {
                                        toast.error('Erro ao excluir');
                                      }
                                    }
                                  }}
                                  className="text-red-600 hover:text-red-900 p-1 rounded"
                                  title="Excluir"
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    
                    {(!filteredTransacoes.receitas || filteredTransacoes.receitas.length === 0) && 
                     (!filteredTransacoes.despesas || filteredTransacoes.despesas.length === 0) && (
                      <tr>
                        <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                          Nenhuma receita ou despesa cadastrada
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* Tabela de Despesas Mensais */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-8">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h3 className="text-lg font-bold text-gray-900">Despesas Mensais</h3>
              <button
                onClick={() => setTabelaDespesasMensaisExpandida(!tabelaDespesasMensaisExpandida)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {tabelaDespesasMensaisExpandida ? (
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                ) : (
                  <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
              </button>
            </div>

            {tabelaDespesasMensaisExpandida && (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ano</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mês</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoria</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategoria</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {despesasMensais && despesasMensais.length > 0 ? (
                      despesasMensais.map((despesa) => (
                        <tr key={despesa.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 text-sm text-gray-900">{despesa.ano}</td>
                          <td className="px-6 py-4 text-sm text-gray-900">{despesa.mes}</td>
                          <td className="px-6 py-4 text-sm font-medium text-gray-900">{despesa.categoria}</td>
                          <td className="px-6 py-4 text-sm text-gray-500">{despesa.subcategoria || '-'}</td>
                          <td className="px-6 py-4 text-sm font-bold text-red-600">{formatCurrency(despesa.valor)}</td>
                          <td className="px-6 py-4 text-sm font-medium">
                            <div className="flex space-x-2">
                              <button
                                onClick={() => setEditingTransaction(despesa)}
                                className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                                title="Editar"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                              <button
                                onClick={async () => {
                                  if (window.confirm('Deseja excluir esta despesa mensal?')) {
                                    try {
                                      await axios.delete(`${API}/financas/despesas-mensais/${despesa.id}`, getAuthHeaders());
                                      toast.success('Despesa mensal excluída');
                                      carregarDados();
                                    } catch (error) {
                                      toast.error('Erro ao excluir');
                                    }
                                  }
                                }}
                                className="text-red-600 hover:text-red-900 p-1 rounded"
                                title="Excluir"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="px-6 py-12 text-center text-gray-500">
                          Nenhuma despesa mensal cadastrada
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          
          {/* Seção Compras Parceladas */}
          <SecaoComprasParceladas carregarDados={carregarDados} />
          </>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Poupança' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Banco</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Transação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Tesouro Direto' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo do Título</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantidade</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Transação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo de Reserva</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor Investido</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantidade</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo de Investimento</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data da Aplicação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dias de Vencimento</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data de Vencimento</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor Investido</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rentabilidade (% a.a.)</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Retorno Bruto Estimado</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cotação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">IOF</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Resultado</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : currentTemplate === 'Viagem' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Viagem</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rendimento</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Empresa</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Setor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qtd</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Preço</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Corretagem</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Emolumentos</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Preço Médio</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoria</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentTemplate === 'Finanças Pessoais' ? (
                  // Tabela simplificada de Finanças Pessoais
                  <>
                    {filteredTransacoes.receitas && filteredTransacoes.receitas.length > 0 && (
                      <>
                        <tr className="bg-green-50">
                          <td colSpan="12" className="px-6 py-3 text-sm font-bold text-green-800">RECEITAS</td>
                        </tr>
                        {filteredTransacoes.receitas.map((receita) => (
                          <tr key={receita.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{receita.origem}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{formatDate(receita.data)}</td>
                            <td className="px-6 py-4 text-sm font-bold text-green-600">{formatCurrency(receita.valor)}</td>
                            <td className="px-6 py-4 text-sm font-medium">
                              <button
                                onClick={async () => {
                                  if (window.confirm('Deseja excluir esta receita?')) {
                                    try {
                                      await axios.delete(`${API}/financas/receitas/${receita.id}`, getAuthHeaders());
                                      toast.success('Receita excluída');
                                      carregarDados();
                                    } catch (error) {
                                      toast.error('Erro ao excluir');
                                    }
                                  }
                                }}
                                className="text-red-600 hover:text-red-900"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    
                    {filteredTransacoes.despesas && filteredTransacoes.despesas.length > 0 && (
                      <>
                        <tr className="bg-red-50">
                          <td colSpan="12" className="px-6 py-3 text-sm font-bold text-red-800">DESPESAS</td>
                        </tr>
                        {filteredTransacoes.despesas.map((despesa) => (
                          <tr key={despesa.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 text-sm font-medium text-gray-900">{despesa.categoria}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{despesa.subcategoria || '-'}</td>
                            <td className="px-6 py-4 text-sm text-gray-500">{formatDate(despesa.data)}</td>
                            <td className="px-6 py-4 text-sm font-bold text-red-600">{formatCurrency(despesa.valor)}</td>
                            <td className="px-6 py-4 text-sm font-medium">
                              <button
                                onClick={async () => {
                                  if (window.confirm('Deseja excluir esta despesa?')) {
                                    try {
                                      await axios.delete(`${API}/financas/despesas/${despesa.id}`, getAuthHeaders());
                                      toast.success('Despesa excluída');
                                      carregarDados();
                                    } catch (error) {
                                      toast.error('Erro ao excluir');
                                    }
                                  }
                                }}
                                className="text-red-600 hover:text-red-900"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                    
                    {(!filteredTransacoes.receitas || filteredTransacoes.receitas.length === 0) && 
                     (!filteredTransacoes.despesas || filteredTransacoes.despesas.length === 0) && (
                      <tr>
                        <td colSpan="12" className="px-6 py-12 text-center text-gray-500">
                          Nenhuma receita ou despesa cadastrada
                        </td>
                      </tr>
                    )}
                  </>
                ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Poupança' ? (
                  // Tabela para Poupança
                  (Array.isArray(filteredTransacoes) ? filteredTransacoes : []).map((transacao) => (
                    <tr key={transacao.id} className="hover:bg-gray-50" data-testid={`poupanca-row-${transacao.id}`}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{transacao.banco}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(transacao.data)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatCurrency(transacao.valor)}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          transacao.tipo_transacao === 'Investido' ? 'bg-green-100 text-green-800' : 
                          transacao.tipo_transacao === 'Retirado' ? 'bg-red-100 text-red-800' :
                          'bg-blue-100 text-blue-800'
                        }`}>
                          {transacao.tipo_transacao}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setEditingTransaction(transacao)}
                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                            data-testid={`edit-poupanca-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => excluirRendaFixa(transacao.id)}
                            className="text-red-600 hover:text-red-900 p-1 rounded"
                            data-testid={`delete-poupanca-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Tesouro Direto' ? (
                  // Tabela para Tesouro Direto
                  (Array.isArray(filteredTransacoes) ? filteredTransacoes : []).map((transacao) => (
                    <tr key={transacao.id} className="hover:bg-gray-50" data-testid={`tesouro-row-${transacao.id}`}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{transacao.tipo_titulo}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(transacao.data)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatCurrency(transacao.valor)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{transacao.quantidade}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          transacao.tipo_transacao === 'Investido' ? 'bg-green-100 text-green-800' : 
                          transacao.tipo_transacao === 'Retirado' ? 'bg-red-100 text-red-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {transacao.tipo_transacao || (transacao.quantidade > 0 ? 'Investido' : 'Retirado')}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setEditingTransaction(transacao)}
                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                            data-testid={`edit-tesouro-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => excluirRendaFixa(transacao.id)}
                            className="text-red-600 hover:text-red-900 p-1 rounded"
                            data-testid={`delete-tesouro-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor' ? (
                  // Tabela para Reserva de Valor
                  filteredReservaValorTransacoes.map((transacao) => (
                    <tr key={transacao.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{transacao.tipo_reserva}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(transacao.data)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatCurrency(transacao.valor_investido)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {transacao.quantidade} {transacao.tipo_reserva === 'Ouro' ? 'g' : transacao.tipo_reserva === 'Bitcoin' || transacao.tipo_reserva === 'Ethereum' ? transacao.tipo_reserva : 'unid'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          transacao.acao === 'Compra' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                          {transacao.acao}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setEditingReservaTransacao(transacao)}
                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={async () => {
                              if (window.confirm('Deseja excluir esta transação?')) {
                                try {
                                  await axios.delete(`${API}/reserva-valor/transacoes/${transacao.id}`, getAuthHeaders());
                                  toast.success('Transação excluída');
                                  carregarDados();
                                } catch (error) {
                                  toast.error('Erro ao excluir');
                                }
                              }
                            }}
                            className="text-red-600 hover:text-red-900 p-1 rounded"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Fixed Income' ? (
                  // Tabela para Fixed Income
                  <FixedIncomeTableRows
                    transacoes={filteredFixedIncomeTransacoes}
                    onEdit={setEditingFixedIncome}
                    onConcluir={concluirFixedIncome}
                    onDelete={deleteFixedIncome}
                  />
                ) : currentTemplate === 'Wall Street' && modalidadeExterior === 'Compra Dólar' ? (
                  // Tabela para Compra Dólar
                  <CompraDolarTableRows
                    transacoes={compraDolarTransacoes}
                    onEdit={setEditingCompraDolar}
                    onDelete={deleteCompraDolar}
                  />
                ) : currentTemplate === 'Viagem' ? (
                  // Tabela para Viagem
                  (Array.isArray(filteredTransacoes) ? filteredTransacoes : []).map((transacao) => (
                    <tr key={transacao.id} className="hover:bg-gray-50" data-testid={`viagem-row-${transacao.id}`}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{transacao.nome_viagem}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(transacao.data)}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          transacao.tipo_transacao === 'Aporte' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                          {transacao.tipo_transacao}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatCurrency(transacao.valor)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatCurrency(transacao.rendimento || 0)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => excluirTransacaoViagem(transacao.id)}
                            className="text-red-600 hover:text-red-900 p-1 rounded"
                            data-testid={`delete-viagem-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  // Tabela para B3 e Wall Street (original)
                  (Array.isArray(filteredTransacoes) ? filteredTransacoes : []).map((transacao) => (
                    <tr key={transacao.id} className="hover:bg-gray-50" data-testid={`transaction-row-${transacao.id}`}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{transacao.empresa}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{transacao.codigo}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{transacao.setor}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(transacao.data)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{transacao.quantidade}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatCurrency(transacao.preco)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatCurrency(transacao.total)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatCurrency(transacao.corretagem)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatCurrency(transacao.emolumentos)}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatCurrency(transacao.preco_medio)}</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          transacao.tipo === 'Compra' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                        }`}>
                          {transacao.tipo}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{transacao.categoria}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setEditingTransaction(transacao)}
                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                            data-testid={`edit-transaction-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => excluirTransacao(transacao.id)}
                            className="text-red-600 hover:text-red-900 p-1 rounded"
                            data-testid={`delete-transaction-${transacao.id}`}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
                
                {(filteredTransacoes.length === 0 && currentTemplate !== 'Wall Street' && !(currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Reserva de Valor')) && (
                  <tr>
                    <td colSpan={
                      currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Poupança' ? "5" :
                      currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Tesouro Direto' ? "7" : "13"
                    } className="px-6 py-8 text-center text-gray-500">
                      {searchTerm ? 'Nenhuma transação encontrada' : 'Nenhuma transação cadastrada'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        )}
      </div>

      {/* Modal Adicionar/Editar */}
      {(showAddForm || editingTransaction) && (
        currentTemplate === 'Finanças Pessoais' ? (
          editingTransaction ? (
            <EditarTransacaoFinancasModal
              transaction={editingTransaction}
              onClose={() => setEditingTransaction(null)}
              onSuccess={() => {
                setEditingTransaction(null);
                carregarDados();
              }}
            />
          ) : (
            <NovaTransacaoFinancasModal
              onClose={() => setShowAddForm(false)}
              onSuccess={() => {
                setShowAddForm(false);
                carregarDados();
              }}
            />
          )
        ) : currentTemplate === 'BR Renda Fixa' ? (
          <RendaFixaModal
            transaction={editingTransaction}
            tipoInvestimento={tipoInvestimento}
            onClose={() => {
              setShowAddForm(false);
              setEditingTransaction(null);
            }}
            onSuccess={() => {
              carregarDados();
              setShowAddForm(false);
              setEditingTransaction(null);
            }}
          />
        ) : (
          <TransactionModal
            transaction={editingTransaction}
            onClose={() => {
              setShowAddForm(false);
              setEditingTransaction(null);
            }}
            onSuccess={() => {
              carregarDados();
              setShowAddForm(false);
              setEditingTransaction(null);
            }}
          />
        )
      )}

      {/* Modal Gerenciar Empresas/Bancos/Títulos/Viagens */}
      {showManageCompanies && (
        currentTemplate === 'Viagem' ? (
          <ManageViagensModal
            onClose={() => setShowManageCompanies(false)}
          />
        ) : currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Tesouro Direto' ? (
          <ManageTitulosModal
            onClose={() => setShowManageCompanies(false)}
          />
        ) : (
          <ManageCompaniesModal
            onClose={() => setShowManageCompanies(false)}
          />
        )
      )}

      {/* Modal Gerenciar Reservas de Valor */}
      {showGerenciarReservas && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Gerenciar Reservas de Valor</h2>
              <button
                onClick={() => setShowGerenciarReservas(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
              <button
                onClick={async () => {
                  const nome = prompt('Nome da nova reserva de valor:');
                  if (nome) {
                    try {
                      await axios.post(`${API}/reserva-valor/cadastros`, { nome, meta: 0 }, getAuthHeaders());
                      toast.success('Reserva criada com sucesso');
                      carregarDados();
                    } catch (error) {
                      toast.error('Erro ao criar reserva');
                    }
                  }
                }}
                className="mb-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
              >
                + Adicionar Nova Reserva
              </button>
              
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta (R$)</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {reservaValorCadastros.map((reserva) => (
                      <tr key={reserva.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{reserva.nome}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <input
                            type="number"
                            defaultValue={reserva.meta}
                            onBlur={async (e) => {
                              try {
                                await axios.put(`${API}/reserva-valor/cadastros/${reserva.id}?meta=${e.target.value}`, {}, getAuthHeaders());
                                toast.success('Meta atualizada');
                                carregarDados();
                              } catch (error) {
                                toast.error('Erro ao atualizar meta');
                              }
                            }}
                            className="w-32 px-2 py-1 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <button
                            onClick={async () => {
                              if (window.confirm(`Deseja excluir ${reserva.nome}?`)) {
                                try {
                                  await axios.delete(`${API}/reserva-valor/cadastros/${reserva.id}`, getAuthHeaders());
                                  toast.success('Reserva excluída');
                                  carregarDados();
                                } catch (error) {
                                  toast.error('Erro ao excluir');
                                }
                              }
                            }}
                            className="text-red-600 hover:text-red-900"
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="p-6 border-t border-gray-200">
              <button
                onClick={() => setShowGerenciarReservas(false)}
                className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nova Transação - Reserva de Valor */}
      {showNovaTransacaoReserva && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Nova Transação - Reserva de Valor</h2>
              <button
                onClick={() => {
                  setShowNovaTransacaoReserva(false);
                  setEditingReservaTransacao(null);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              <form onSubmit={async (e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                
                const transacao = {
                  tipo_reserva: formData.get('tipo_reserva'),
                  data: formData.get('data'),
                  valor_investido: parseFloat(formData.get('valor_investido')),
                  quantidade: parseFloat(formData.get('quantidade')),
                  acao: formData.get('acao')
                };
                
                try {
                  if (editingReservaTransacao) {
                    await axios.put(`${API}/reserva-valor/transacoes/${editingReservaTransacao.id}`, transacao, getAuthHeaders());
                    toast.success('Transação atualizada com sucesso');
                  } else {
                    await axios.post(`${API}/reserva-valor/transacoes`, transacao, getAuthHeaders());
                    toast.success('Transação criada com sucesso');
                  }
                  setShowNovaTransacaoReserva(false);
                  setEditingReservaTransacao(null);
                  carregarDados();
                } catch (error) {
                  console.error('Erro:', error);
                  toast.error('Erro ao salvar transação');
                }
              }}>
                <div className="grid grid-cols-2 gap-4">
                  <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tipo de Reserva de Valor
                    </label>
                    <select
                      name="tipo_reserva"
                      required
                      defaultValue={editingReservaTransacao?.tipo_reserva || ''}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Selecione...</option>
                      {reservaValorCadastros.length === 0 ? (
                        <option value="" disabled>Carregando reservas...</option>
                      ) : (
                        reservaValorCadastros.map((reserva) => (
                          <option key={reserva.id} value={reserva.nome}>
                            {reserva.nome}
                          </option>
                        ))
                      )}
                    </select>
                  </div>
                  
                  <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ação
                    </label>
                    <select
                      name="acao"
                      required
                      defaultValue={editingReservaTransacao?.acao || 'Compra'}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="Compra">Compra</option>
                      <option value="Venda">Venda</option>
                    </select>
                  </div>
                  
                  <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Quantidade
                    </label>
                    <input
                      type="number"
                      name="quantidade"
                      step="0.00000001"
                      required
                      defaultValue={editingReservaTransacao?.quantidade || ''}
                      placeholder="Quantidade"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  
                  <div className="col-span-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Data
                    </label>
                    <input
                      type="date"
                      name="data"
                      required
                      defaultValue={editingReservaTransacao?.data || ''}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Valor Investido (R$)
                    </label>
                    <input
                      type="number"
                      name="valor_investido"
                      step="0.01"
                      required
                      defaultValue={editingReservaTransacao?.valor_investido || ''}
                      placeholder="Valor da transação"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
                
                <div className="flex gap-4 mt-6">
                  <button
                    type="button"
                    onClick={() => {
                      setShowNovaTransacaoReserva(false);
                      setEditingReservaTransacao(null);
                    }}
                    className="flex-1 px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-6 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg"
                  >
                    {editingReservaTransacao ? 'Atualizar' : 'Salvar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nova Transação - Fixed Income */}
      {showNovaTransacaoFixedIncome && (
        <NovaTransacaoFixedIncomeModal
          onClose={() => {
            setShowNovaTransacaoFixedIncome(false);
            setEditingFixedIncome(null);
          }}
          onSuccess={() => {
            setShowNovaTransacaoFixedIncome(false);
            setEditingFixedIncome(null);
            carregarDados();
          }}
          fixedIncomeTipos={fixedIncomeTipos}
          editingTransaction={editingFixedIncome}
        />
      )}

      {/* Modal Gerenciar Tipos - Fixed Income */}
      {showGerenciarTiposFixedIncome && (
        <GerenciarTiposFixedIncomeModal
          onClose={() => setShowGerenciarTiposFixedIncome(false)}
          onSuccess={() => carregarDados()}
          fixedIncomeTipos={fixedIncomeTipos}
        />
      )}

      {/* Modal Nova Transação - Compra Dólar */}
      {showNovaTransacaoCompraDolar && (
        <NovaTransacaoCompraDolarModal
          onClose={() => {
            setShowNovaTransacaoCompraDolar(false);
            setEditingCompraDolar(null);
          }}
          onSuccess={() => {
            setShowNovaTransacaoCompraDolar(false);
            setEditingCompraDolar(null);
            carregarDados();
          }}
          editingTransaction={editingCompraDolar}
        />
      )}

      {/* Modal Gerenciar Cadastro B3 */}
      {showGerenciarCadastroB3 && (
        <GerenciarCadastroB3Modal
          onClose={() => setShowGerenciarCadastroB3(false)}
          onSuccess={() => carregarDados()}
        />
      )}

      {/* Modal Gerenciar Cadastro Exterior */}
      {showGerenciarCadastroExterior && (
        <GerenciarCadastroExteriorModal
          onClose={() => setShowGerenciarCadastroExterior(false)}
          onSuccess={() => carregarDados()}
        />
      )}

      {/* Modal Gastos de Viagem */}
      {showGastosViagem && selectedViagemGastos && (
        <ModalGastosViagem
          viagem={selectedViagemGastos}
          estatisticas={selectedViagemGastos}
          onClose={() => {
            setShowGastosViagem(false);
            setSelectedViagemGastos(null);
          }}
          getAuthHeaders={getAuthHeaders}
          onUpdate={carregarDados}
        />
      )}

      {/* Modal Nova Transação */}
      {showAddForm && (
        currentTemplate === 'Finanças Pessoais' ? (
          <NovaTransacaoFinancasModal
            onClose={() => setShowAddForm(false)}
            onSuccess={() => {
              setShowAddForm(false);
              carregarDados();
            }}
          />
        ) : currentTemplate === 'Viagem' ? (
          <NovaTransacaoViagemModal
            onClose={() => setShowAddForm(false)}
            onSuccess={() => {
              setShowAddForm(false);
              carregarDados();
            }}
          />
        ) : currentTemplate === 'BR Renda Fixa' ? (
          <RendaFixaModal
            tipoInvestimento={tipoInvestimento}
            onClose={() => setShowAddForm(false)}
            onSuccess={() => {
              setShowAddForm(false);
              carregarDados();
            }}
          />
        ) : (
          <TransactionModal
            onClose={() => setShowAddForm(false)}
            onSuccess={() => {
              setShowAddForm(false);
              carregarDados();
            }}
          />
        )
      )}

      {/* Modal Novo Gasto Mensal */}
      {showNovoGastoMensal && (
        <NovoGastoMensalModal
          onClose={() => setShowNovoGastoMensal(false)}
          onSuccess={() => {
            setShowNovoGastoMensal(false);
            carregarDados();
          }}
        />
      )}
    </div>
  );
}

// Componente de Autocomplete
function AutocompleteInput({ value, onChange, placeholder, field, testId, onEmpresaSelected }) {
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const fetchSuggestions = async (termo) => {
    if (termo.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      // Get current template from localStorage or default to B3
      const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
      const response = await axios.get(`${API}/empresas/search/${currentTemplate}/${field}/${termo}`, getAuthHeaders());
      setSuggestions(response.data);
    } catch (error) {
      console.error('Erro ao buscar sugestões:', error);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    fetchSuggestions(newValue);
    setShowSuggestions(true);
  };

  const selectSuggestion = async (suggestion) => {
    onChange(suggestion);
    setShowSuggestions(false);
    setSuggestions([]);

    // Se é campo empresa e há callback, buscar dados completos
    if (field === 'empresa' && onEmpresaSelected) {
      try {
        const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
        const response = await axios.get(`${API}/empresas/buscar-por-nome/${currentTemplate}/${encodeURIComponent(suggestion)}`, getAuthHeaders());
        onEmpresaSelected(response.data);
      } catch (error) {
        console.error('Erro ao buscar dados da empresa:', error);
      }
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
        onFocus={() => value.length >= 2 && setShowSuggestions(suggestions.length > 0)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        placeholder={placeholder}
        required
        data-testid={testId}
      />
      
      {showSuggestions && suggestions.length > 0 && (
        <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-y-auto">
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              onClick={() => selectSuggestion(suggestion)}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
            >
              {suggestion}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Modal para Adicionar/Editar Transação
function TransactionModal({ transaction, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    template: localStorage.getItem('currentTemplate') || 'B3',
    empresa: '',
    codigo: '',
    setor: '',
    data: '',
    quantidade: '',
    preco: '',
    corretagem: '',
    emolumentos: '',
    tipo: 'Compra',
    categoria: 'Bluechips',
    ...transaction
  });
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        quantidade: parseInt(formData.quantidade),
        preco: parseFloat(formData.preco),
        corretagem: parseFloat(formData.corretagem),
        emolumentos: parseFloat(formData.emolumentos)
      };

      if (transaction) {
        await axios.put(`${API}/transacoes/${transaction.id}`, payload, getAuthHeaders());
        toast.success('Transação atualizada com sucesso');
      } else {
        await axios.post(`${API}/transacoes`, payload, getAuthHeaders());
        toast.success('Transação criada com sucesso');
      }
      
      onSuccess();
    } catch (error) {
      toast.error('Erro ao salvar transação');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleEmpresaSelected = (empresaData) => {
    // Preenche automaticamente código, setor e categoria quando empresa é selecionada
    setFormData(prev => ({
      ...prev,
      empresa: empresaData.empresa,
      codigo: empresaData.codigo,
      setor: empresaData.setor,
      categoria: empresaData.categoria || 'Bluechips'
    }));
    toast.success(`Dados da ${empresaData.empresa} preenchidos automaticamente!`);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">
              {transaction ? 'Editar Transação' : 'Nova Transação'}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Empresa
                  <span className="text-xs text-blue-600 ml-2">
                    💡 Selecione uma empresa existente para preencher automaticamente
                  </span>
                </label>
                <AutocompleteInput
                  value={formData.empresa}
                  onChange={(value) => handleChange('empresa', value)}
                  placeholder="Digite o nome da empresa"
                  field="empresa"
                  testId="empresa-input"
                  onEmpresaSelected={handleEmpresaSelected}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Código</label>
                <AutocompleteInput
                  value={formData.codigo}
                  onChange={(value) => handleChange('codigo', value)}
                  placeholder="Digite o código (ex: PETR4)"
                  field="codigo"
                  testId="codigo-input"
                  onEmpresaSelected={handleEmpresaSelected}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Setor</label>
                <AutocompleteInput
                  value={formData.setor}
                  onChange={(value) => handleChange('setor', value)}
                  placeholder="Digite o setor"
                  field="setor"
                  testId="setor-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                <input
                  type="date"
                  value={formData.data}
                  onChange={(e) => handleChange('data', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  data-testid="data-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Quantidade</label>
                <input
                  type="number"
                  value={formData.quantidade}
                  onChange={(e) => handleChange('quantidade', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  min="1"
                  data-testid="quantidade-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Preço</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.preco}
                  onChange={(e) => handleChange('preco', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  min="0"
                  data-testid="preco-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Corretagem</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.corretagem}
                  onChange={(e) => handleChange('corretagem', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  min="0"
                  data-testid="corretagem-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Emolumentos</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.emolumentos}
                  onChange={(e) => handleChange('emolumentos', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  min="0"
                  data-testid="emolumentos-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
                <select
                  value={formData.tipo}
                  onChange={(e) => handleChange('tipo', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  data-testid="tipo-select"
                >
                  <option value="Compra">Compra</option>
                  <option value="Venda">Venda</option>
                </select>
              </div>
            </div>

            <div className="flex justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                data-testid="cancel-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-lg hover:from-blue-700 hover:to-indigo-800 transition-all duration-200 disabled:opacity-50"
                data-testid="save-button"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Renda Fixa
function RendaFixaModal({ transaction, tipoInvestimento, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    tipo_investimento: tipoInvestimento,
    data: '',
    valor: '',
    // Campos para Poupança
    banco: '',
    tipo_transacao: 'Investido',
    // Campos para Tesouro Direto
    sigla_titulo: '',
    quantidade: '',
    ...transaction
  });
  const [loading, setLoading] = useState(false);
  const [bancoSuggestions, setBancoSuggestions] = useState([]);
  const [titulos, setTitulos] = useState([]);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const carregarTitulosModal = async () => {
    try {
      const response = await axios.get(`${API}/titulos`, getAuthHeaders());
      console.log('Títulos carregados no modal:', response.data);
      setTitulos(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar títulos no modal:', error);
      toast.error('Erro ao carregar títulos cadastrados');
      setTitulos([]);
    }
  };

  // Carregar títulos quando o modal abre e é Tesouro Direto
  useEffect(() => {
    console.log('RendaFixaModal montado - tipoInvestimento:', tipoInvestimento);
    if (tipoInvestimento === 'Tesouro Direto') {
      console.log('Iniciando carregamento de títulos...');
      carregarTitulosModal();
    }
  }, [tipoInvestimento]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validar se é Tesouro Direto e tem título selecionado
      if (tipoInvestimento === 'Tesouro Direto' && !formData.sigla_titulo) {
        toast.error('Selecione um título cadastrado');
        setLoading(false);
        return;
      }

      const payload = {
        ...formData,
        tipo_investimento: tipoInvestimento,
        valor: parseFloat(formData.valor),
        quantidade: formData.quantidade ? parseFloat(formData.quantidade) : undefined
      };

      if (transaction && transaction.id) {
        // Edição - usar PUT
        await axios.put(`${API}/renda-fixa/${transaction.id}`, payload, getAuthHeaders());
        toast.success('Transação atualizada com sucesso');
      } else {
        // Criação - usar POST
        await axios.post(`${API}/renda-fixa`, payload, getAuthHeaders());
        toast.success('Transação criada com sucesso');
      }
      
      onSuccess();
    } catch (error) {
      toast.error('Erro ao salvar transação');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Buscar sugestões de bancos
  const fetchBancoSuggestions = async (termo) => {
    if (termo.length < 2) {
      setBancoSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(`${API}/bancos`, getAuthHeaders());
      const filtered = response.data.filter(banco => 
        banco.banco.toLowerCase().includes(termo.toLowerCase())
      );
      setBancoSuggestions(filtered.map(b => b.banco));
    } catch (error) {
      console.error('Erro ao buscar bancos:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">
              {transaction ? 'Editar' : 'Nova'} Transação - {tipoInvestimento}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-renda-fixa-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {tipoInvestimento === 'Poupança' ? (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Banco</label>
                    <input
                      type="text"
                      value={formData.banco}
                      onChange={(e) => {
                        handleChange('banco', e.target.value);
                        fetchBancoSuggestions(e.target.value);
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                      placeholder="Digite o nome do banco"
                      data-testid="banco-input"
                    />
                    {bancoSuggestions.length > 0 && (
                      <div className="absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-40 overflow-y-auto mt-1">
                        {bancoSuggestions.map((suggestion, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              handleChange('banco', suggestion);
                              setBancoSuggestions([]);
                            }}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                          >
                            {suggestion}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Transação</label>
                    <select
                      value={formData.tipo_transacao}
                      onChange={(e) => handleChange('tipo_transacao', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      data-testid="tipo-transacao-select"
                    >
                      <option value="Investido">Investido</option>
                      <option value="Retirado">Retirado</option>
                      <option value="Rendimento">Rendimento</option>
                    </select>
                  </div>
                </>
              ) : (
                <>
                  {/* Campo tipo_transacao para Tesouro Direto */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de Transação *</label>
                    <select
                      value={formData.tipo_transacao}
                      onChange={(e) => handleChange('tipo_transacao', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      required
                      data-testid="tipo-transacao-tesouro-select"
                    >
                      <option value="Investido">Investido (Compra)</option>
                      <option value="Retirado">Retirado (Venda)</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Título *</label>
                    <div className="flex gap-2">
                      <select
                        value={formData.sigla_titulo}
                        onChange={(e) => handleChange('sigla_titulo', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        required
                        data-testid="sigla-titulo-select"
                      >
                        <option value="">
                          {titulos.length === 0 ? 'Carregando títulos...' : 'Selecione um título'}
                        </option>
                        {titulos.map((titulo) => (
                          <option key={titulo.id} value={titulo.sigla_titulo}>
                            {titulo.sigla_titulo} - {titulo.classificacao}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={carregarTitulosModal}
                        className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        data-testid="reload-titulos-button"
                      >
                        🔄
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Quantidade *</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.quantidade}
                      onChange={(e) => handleChange('quantidade', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Quantidade de títulos"
                      required
                      min="0.01"
                      data-testid="quantidade-titulo-input"
                    />
                  </div>
                </>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                <input
                  type="date"
                  value={formData.data}
                  onChange={(e) => handleChange('data', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  data-testid="data-renda-fixa-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Valor</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.valor}
                  onChange={(e) => handleChange('valor', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  required
                  min="0"
                  placeholder="Valor da transação"
                  data-testid="valor-renda-fixa-input"
                />
              </div>
            </div>

            <div className="flex justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                data-testid="cancel-renda-fixa-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-orange-600 to-amber-700 text-white rounded-lg hover:from-orange-700 hover:to-amber-800 transition-all duration-200 disabled:opacity-50"
                data-testid="save-renda-fixa-button"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Gerenciar Cadastros de Empresas
function ManageCompaniesModal({ onClose }) {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingMeta, setEditingMeta] = useState(null);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  useEffect(() => {
    carregarEmpresas();
  }, []);

  const carregarEmpresas = async () => {
    try {
      const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
      const tipoInvestimento = localStorage.getItem('tipoInvestimento') || 'Poupança';
      
      if (currentTemplate === 'BR Renda Fixa') {
        if (tipoInvestimento === 'Poupança') {
          const response = await axios.get(`${API}/bancos`, getAuthHeaders());
          setEmpresas(response.data);
        } else {
          const response = await axios.get(`${API}/titulos`, getAuthHeaders());
          setEmpresas(response.data);
        }
      } else {
        const response = await axios.get(`${API}/empresas/${currentTemplate}`, getAuthHeaders());
        setEmpresas(response.data);
      }
    } catch (error) {
      toast.error('Erro ao carregar cadastros');
    } finally {
      setLoading(false);
    }
  };

  const excluirEmpresa = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este cadastro?')) {
      try {
        const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
        const tipoInvestimento = localStorage.getItem('tipoInvestimento') || 'Poupança';
        
        if (currentTemplate === 'BR Renda Fixa') {
          if (tipoInvestimento === 'Poupança') {
            await axios.delete(`${API}/bancos/${id}`, getAuthHeaders());
            toast.success('Banco excluído com sucesso');
          } else {
            await axios.delete(`${API}/titulos/${id}`, getAuthHeaders());
            toast.success('Título excluído com sucesso');
          }
        } else {
          await axios.delete(`${API}/empresas/${id}`, getAuthHeaders());
          toast.success('Empresa excluída com sucesso');
        }
        
        carregarEmpresas();
      } catch (error) {
        toast.error('Erro ao excluir cadastro');
      }
    }
  };

  const atualizarMeta = async (empresaId, metaData) => {
    try {
      const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
      const tipoInvestimento = localStorage.getItem('tipoInvestimento') || 'Poupança';
      
      if (currentTemplate === 'BR Renda Fixa') {
        if (tipoInvestimento === 'Poupança') {
          await axios.put(`${API}/bancos/${empresaId}`, metaData, getAuthHeaders());
        } else {
          await axios.put(`${API}/titulos/${empresaId}`, metaData, getAuthHeaders());
        }
      } else {
        await axios.put(`${API}/empresas/${empresaId}`, metaData, getAuthHeaders());
      }
      
      toast.success('Meta atualizada com sucesso');
      carregarEmpresas();
      setEditingMeta(null);
    } catch (error) {
      toast.error('Erro ao atualizar meta');
    }
  };

  const filteredEmpresas = empresas.filter(empresa => {
    const currentTemplate = localStorage.getItem('currentTemplate') || 'B3';
    const tipoInvestimento = localStorage.getItem('tipoInvestimento') || 'Poupança';
    
    if (currentTemplate === 'BR Renda Fixa') {
      if (tipoInvestimento === 'Poupança') {
        return empresa.banco.toLowerCase().includes(searchTerm.toLowerCase());
      } else {
        return empresa.sigla_titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
               (empresa.classificacao && empresa.classificacao.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    } else {
      return empresa.empresa.toLowerCase().includes(searchTerm.toLowerCase()) ||
             empresa.codigo.toLowerCase().includes(searchTerm.toLowerCase()) ||
             empresa.setor.toLowerCase().includes(searchTerm.toLowerCase());
    }
  });

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">
              Gerenciar {
                localStorage.getItem('currentTemplate') === 'BR Renda Fixa' 
                  ? (localStorage.getItem('tipoInvestimento') === 'Poupança' ? 'Bancos' : 'Títulos')
                  : 'Cadastros'
              }
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-manage-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="mb-4">
            <input
              type="text"
              placeholder={
                localStorage.getItem('currentTemplate') === 'BR Renda Fixa' 
                  ? (localStorage.getItem('tipoInvestimento') === 'Poupança' 
                      ? "Buscar por banco..." 
                      : "Buscar por título...")
                  : "Buscar por empresa, código ou setor..."
              }
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              data-testid="search-companies-input"
            />
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Poupança' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Banco</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cadastrado em</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Tesouro Direto' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sigla Título</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Classificação</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Juros Fixo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Indexador</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Vencimento</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Taxa B3 a.a.</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta Básica</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta Desejo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  ) : (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Empresa</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Setor</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta Básica</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Meta Desejo</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Meta</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cadastrado em</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredEmpresas.map((empresa) => (
                  <tr key={empresa.id} className="hover:bg-gray-50" data-testid={`company-row-${empresa.id}`}>
                    {localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Poupança' ? (
                      <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{empresa.banco}</td>
                      </>
                    ) : localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Tesouro Direto' ? (
                      <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{empresa.sigla_titulo}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.classificacao}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.juros_fixo}%</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.indexador || '-'}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{new Date(empresa.vencimento).toLocaleDateString('pt-BR')}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.taxa_b3_aa}%</td>
                      </>
                    ) : (
                      <>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{empresa.empresa}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.codigo}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{empresa.setor}</td>
                      </>
                    )}
                    
                    {/* Meta */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {editingMeta === empresa.id ? (
                        <input
                          type="number"
                          step="0.01"
                          defaultValue={empresa.meta_basica || 0}
                          className="w-24 px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`meta-basica-input-${empresa.id}`}
                        />
                      ) : (
                        <span onClick={() => setEditingMeta(empresa.id)} className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded">
                          {localStorage.getItem('currentTemplate') === 'BR Renda Fixa' 
                            ? formatCurrency(empresa.meta_basica || 0)
                            : (empresa.tipo_meta === 'quantidade' ? empresa.meta_basica || 0 : formatCurrency(empresa.meta_basica || 0))
                          }
                        </span>
                      )}
                    </td>
                    
                    {/* Tipo Meta - só para empresas normais */}
                    {localStorage.getItem('currentTemplate') !== 'BR Renda Fixa' && (
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {editingMeta === empresa.id ? (
                          <select
                            defaultValue={empresa.tipo_meta || 'quantidade'}
                            className="px-2 py-1 border border-gray-300 rounded text-sm"
                            data-testid={`tipo-meta-select-${empresa.id}`}
                          >
                            <option value="quantidade">Quantidade</option>
                            <option value="valor">Valor</option>
                          </select>
                        ) : (
                          <span 
                            onClick={() => setEditingMeta(empresa.id)} 
                            className={`cursor-pointer hover:bg-gray-100 px-2 py-1 rounded inline-flex px-2 text-xs font-semibold rounded-full ${
                              empresa.tipo_meta === 'quantidade' 
                                ? 'bg-blue-100 text-blue-800' 
                                : 'bg-green-100 text-green-800'
                            }`}
                          >
                            {empresa.tipo_meta === 'quantidade' ? 'Quantidade' : 'Valor'}
                          </span>
                        )}
                      </td>
                    )}
                    
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {new Date(empresa.created_at).toLocaleDateString('pt-BR')}
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex space-x-2">
                        {editingMeta === empresa.id ? (
                          <>
                            <button
                              onClick={() => {
                                const metaBasica = parseFloat(document.querySelector(`[data-testid="meta-basica-input-${empresa.id}"]`).value);
                                
                                let updateData = {
                                  meta_basica: metaBasica
                                };
                                
                                // Incluir meta_desejo apenas se não for Poupança
                                const currentTemplate = localStorage.getItem('currentTemplate');
                                const tipoInvestimento = localStorage.getItem('tipoInvestimento');
                                
                                if (!(currentTemplate === 'BR Renda Fixa' && tipoInvestimento === 'Poupança')) {
                                  const metaDesejoInput = document.querySelector(`[data-testid="meta-desejo-input-${empresa.id}"]`);
                                  if (metaDesejoInput) {
                                    updateData.meta_desejo = parseFloat(metaDesejoInput.value);
                                  }
                                }
                                
                                // Só incluir tipo_meta se não for Renda Fixa
                                if (currentTemplate !== 'BR Renda Fixa') {
                                  const tipoMeta = document.querySelector(`[data-testid="tipo-meta-select-${empresa.id}"]`).value;
                                  updateData.tipo_meta = tipoMeta;
                                }
                                
                                atualizarMeta(empresa.id, updateData);
                              }}
                              className="text-green-600 hover:text-green-900 p-1 rounded"
                              data-testid={`save-meta-${empresa.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            </button>
                            <button
                              onClick={() => setEditingMeta(null)}
                              className="text-gray-600 hover:text-gray-900 p-1 rounded"
                              data-testid={`cancel-meta-${empresa.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => setEditingMeta(empresa.id)}
                              className="text-indigo-600 hover:text-indigo-900 p-1 rounded"
                              data-testid={`edit-meta-${empresa.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                            <button
                              onClick={() => excluirEmpresa(empresa.id)}
                              className="text-red-600 hover:text-red-900 p-1 rounded"
                              data-testid={`delete-company-${empresa.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {filteredEmpresas.length === 0 && (
                  <tr>
                    <td colSpan={
                      localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Poupança' ? "4" :
                      localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Tesouro Direto' ? "9" : "8"
                    } className="px-6 py-8 text-center text-gray-500">
                      {searchTerm ? 
                        `Nenhum${localStorage.getItem('currentTemplate') === 'BR Renda Fixa' ? 
                          (localStorage.getItem('tipoInvestimento') === 'Poupança' ? ' banco' : ' título') : 'a empresa'} encontrad${
                            localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Poupança' ? 'o' : 'a'}` : 
                        `Nenhum${localStorage.getItem('currentTemplate') === 'BR Renda Fixa' ? 
                          (localStorage.getItem('tipoInvestimento') === 'Poupança' ? ' banco' : ' título') : 'a empresa'} cadastrad${
                            localStorage.getItem('currentTemplate') === 'BR Renda Fixa' && localStorage.getItem('tipoInvestimento') === 'Poupança' ? 'o' : 'a'}`
                      }
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end pt-4 mt-6">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              data-testid="close-button"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Modal para Gerenciar Títulos do Tesouro Direto
function ManageTitulosModal({ onClose }) {
  const [titulos, setTitulos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingTitulo, setEditingTitulo] = useState(null);
  const [showAddTitulo, setShowAddTitulo] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  useEffect(() => {
    carregarTitulos();
  }, []);

  const carregarTitulos = async () => {
    try {
      const response = await axios.get(`${API}/titulos`, getAuthHeaders());
      setTitulos(response.data);
    } catch (error) {
      toast.error('Erro ao carregar títulos cadastrados');
    } finally {
      setLoading(false);
    }
  };

  const excluirTitulo = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este título?')) {
      try {
        await axios.delete(`${API}/titulos/${id}`, getAuthHeaders());
        toast.success('Título excluído com sucesso');
        carregarTitulos();
      } catch (error) {
        toast.error('Erro ao excluir título');
      }
    }
  };

  const atualizarTitulo = async (tituloId, tituloData) => {
    try {
      await axios.put(`${API}/titulos/${tituloId}`, tituloData, getAuthHeaders());
      toast.success('Título atualizado com sucesso');
      carregarTitulos();
      setEditingTitulo(null);
    } catch (error) {
      toast.error('Erro ao atualizar título');
    }
  };

  const filteredTitulos = titulos.filter(titulo =>
    titulo.sigla_titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (titulo.classificacao && titulo.classificacao.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600 mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Gerenciar Títulos</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-titulos-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="flex justify-between items-center mb-4">
            <input
              type="text"
              placeholder="Buscar por sigla ou classificação..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flex-1 mr-4 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              data-testid="search-titulos-input"
            />
            
            <button
              onClick={() => setShowAddTitulo(true)}
              className="px-4 py-2 bg-gradient-to-r from-orange-600 to-amber-700 text-white rounded-lg hover:from-orange-700 hover:to-amber-800 transition-all duration-200 flex items-center gap-2"
              data-testid="add-titulo-button"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Novo Título
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Sigla</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Classificação</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Juros Fixo</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Indexador</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Juros do Indexador (%)</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vencimento</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Taxa B3 a.a.</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Meta</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredTitulos.map((titulo) => (
                  <tr key={titulo.id} className="hover:bg-gray-50" data-testid={`titulo-row-${titulo.id}`}>
                    <td className="px-4 py-4 text-sm font-medium text-gray-900">{titulo.sigla_titulo}</td>
                    
                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <select
                          defaultValue={titulo.classificacao}
                          className="px-2 py-1 border border-gray-300 rounded text-sm w-full"
                          data-testid={`classificacao-select-${titulo.id}`}
                        >
                          <option value="Pré-fixado">Pré-fixado</option>
                          <option value="Pós-fixado">Pós-fixado</option>
                          <option value="Híbrido">Híbrido</option>
                        </select>
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {titulo.classificacao}
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <input
                          type="number"
                          step="0.01"
                          defaultValue={titulo.juros_fixo || 0}
                          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`juros-fixo-input-${titulo.id}`}
                        />
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {titulo.juros_fixo}%
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <select
                          defaultValue={titulo.indexador || ''}
                          className="px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`indexador-select-${titulo.id}`}
                        >
                          <option value="">Nenhum</option>
                          <option value="IPCA">IPCA</option>
                          <option value="SELIC">SELIC</option>
                        </select>
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {titulo.indexador || '-'}
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <input
                          type="number"
                          step="0.01"
                          defaultValue={titulo.juros_indexador || 0}
                          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`juros-indexador-input-${titulo.id}`}
                        />
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {titulo.juros_indexador || 0}%
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <input
                          type="date"
                          defaultValue={titulo.vencimento}
                          className="px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`vencimento-input-${titulo.id}`}
                        />
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {new Date(titulo.vencimento).toLocaleDateString('pt-BR')}
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <input
                          type="number"
                          step="0.01"
                          defaultValue={titulo.taxa_b3_aa}
                          className="w-20 px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`taxa-b3-input-${titulo.id}`}
                        />
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {titulo.taxa_b3_aa}%
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm text-gray-500">
                      {editingTitulo === titulo.id ? (
                        <input
                          type="number"
                          step="0.01"
                          defaultValue={titulo.meta || 0}
                          className="w-24 px-2 py-1 border border-gray-300 rounded text-sm"
                          data-testid={`meta-titulo-input-${titulo.id}`}
                        />
                      ) : (
                        <span 
                          onClick={() => setEditingTitulo(titulo.id)} 
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1 rounded"
                        >
                          {formatCurrency(titulo.meta || 0)}
                        </span>
                      )}
                    </td>

                    <td className="px-4 py-4 text-sm font-medium">
                      <div className="flex space-x-2">
                        {editingTitulo === titulo.id ? (
                          <>
                            <button
                              onClick={() => {
                                const classificacao = document.querySelector(`[data-testid="classificacao-select-${titulo.id}"]`).value;
                                const jurosFixo = parseFloat(document.querySelector(`[data-testid="juros-fixo-input-${titulo.id}"]`).value);
                                const indexador = document.querySelector(`[data-testid="indexador-select-${titulo.id}"]`).value;
                                const jurosIndexador = parseFloat(document.querySelector(`[data-testid="juros-indexador-input-${titulo.id}"]`).value);
                                const vencimento = document.querySelector(`[data-testid="vencimento-input-${titulo.id}"]`).value;
                                const taxaB3 = parseFloat(document.querySelector(`[data-testid="taxa-b3-input-${titulo.id}"]`).value);
                                const meta = parseFloat(document.querySelector(`[data-testid="meta-titulo-input-${titulo.id}"]`).value);
                                
                                atualizarTitulo(titulo.id, {
                                  classificacao,
                                  juros_fixo: jurosFixo,
                                  indexador: indexador || null,
                                  juros_indexador: jurosIndexador,
                                  vencimento,
                                  taxa_b3_aa: taxaB3,
                                  meta: meta
                                });
                              }}
                              className="text-green-600 hover:text-green-900 p-1 rounded"
                              data-testid={`save-titulo-${titulo.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            </button>
                            <button
                              onClick={() => setEditingTitulo(null)}
                              className="text-gray-600 hover:text-gray-900 p-1 rounded"
                              data-testid={`cancel-titulo-${titulo.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => setEditingTitulo(titulo.id)}
                              className="text-orange-600 hover:text-orange-900 p-1 rounded"
                              data-testid={`edit-titulo-${titulo.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                              </svg>
                            </button>
                            <button
                              onClick={() => excluirTitulo(titulo.id)}
                              className="text-red-600 hover:text-red-900 p-1 rounded"
                              data-testid={`delete-titulo-${titulo.id}`}
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                
                {filteredTitulos.length === 0 && (
                  <tr>
                    <td colSpan="9" className="px-6 py-8 text-center text-gray-500">
                      {searchTerm ? 'Nenhum título encontrado' : 'Nenhum título cadastrado'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="mt-6 text-sm text-gray-600 bg-orange-50 p-4 rounded-lg">
            <p><strong>💡 Dica:</strong> Clique nos campos para editá-los. Cadastre títulos completos para ter cálculos automáticos de retorno nas transações.</p>
          </div>

          <div className="flex justify-end pt-4">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              data-testid="close-titulos-button"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>

      {/* Modal Adicionar Título */}
      {showAddTitulo && (
        <AddTituloModal
          onClose={() => setShowAddTitulo(false)}
          onSuccess={() => {
            setShowAddTitulo(false);
            carregarTitulos();
          }}
        />
      )}
    </div>
  );
}

// Modal para Adicionar Novo Título
function AddTituloModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    sigla_titulo: '',
    classificacao: 'Pré-fixado',
    juros_fixo: 0,
    indexador: '',
    juros_indexador: 0,
    vencimento: '',
    taxa_b3_aa: 0,
    meta: 0
  });
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...formData,
        tipo_titulo: formData.sigla_titulo, // Usar sigla como tipo
        juros_fixo: parseFloat(formData.juros_fixo),
        juros_indexador: parseFloat(formData.juros_indexador || 0),
        taxa_b3_aa: parseFloat(formData.taxa_b3_aa),
        meta: parseFloat(formData.meta),
        indexador: formData.indexador || null
      };

      await axios.post(`${API}/titulos`, payload, getAuthHeaders());
      toast.success('Título cadastrado com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao cadastrar título');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-60">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-bold text-gray-900">Cadastrar Novo Título</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-add-titulo-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Sigla do Título</label>
                <input
                  type="text"
                  value={formData.sigla_titulo}
                  onChange={(e) => setFormData({...formData, sigla_titulo: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                  placeholder="Ex: Tesouro SELIC 2029"
                  data-testid="add-sigla-titulo-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Classificação</label>
                <select
                  value={formData.classificacao}
                  onChange={(e) => setFormData({...formData, classificacao: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="add-classificacao-select"
                >
                  <option value="Pré-fixado">Pré-fixado</option>
                  <option value="Pós-fixado">Pós-fixado</option>
                  <option value="Híbrido">Híbrido</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Juros Fixo (% a.a.)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.juros_fixo}
                  onChange={(e) => setFormData({...formData, juros_fixo: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  placeholder="Ex: 12.50"
                  data-testid="add-juros-fixo-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Indexador</label>
                <select
                  value={formData.indexador}
                  onChange={(e) => setFormData({...formData, indexador: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  data-testid="add-indexador-select"
                >
                  <option value="">Nenhum</option>
                  <option value="IPCA">IPCA</option>
                  <option value="SELIC">SELIC</option>
                </select>
              </div>

              {formData.indexador && formData.indexador !== '' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Juros do Indexador (% a.a.)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.juros_indexador}
                    onChange={(e) => setFormData({...formData, juros_indexador: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    placeholder="0"
                    data-testid="add-juros-indexador-input"
                  />
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Vencimento</label>
                <input
                  type="date"
                  value={formData.vencimento}
                  onChange={(e) => setFormData({...formData, vencimento: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                  data-testid="add-vencimento-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Taxa B3 a.a. (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.taxa_b3_aa}
                  onChange={(e) => setFormData({...formData, taxa_b3_aa: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                  placeholder="Ex: 13.75"
                  data-testid="add-taxa-b3-input"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta (R$)</label>
                <input
                  type="number"
                  step="0.01"
                  value={formData.meta}
                  onChange={(e) => setFormData({...formData, meta: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  placeholder="Ex: 10000"
                  data-testid="add-meta-input"
                />
              </div>
            </div>

            <div className="flex justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                data-testid="cancel-add-titulo-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-orange-600 to-amber-700 text-white rounded-lg hover:from-orange-700 hover:to-amber-800 transition-all duration-200 disabled:opacity-50"
                data-testid="save-add-titulo-button"
              >
                {loading ? 'Cadastrando...' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Gerenciar Viagens
function ManageViagensModal({ onClose }) {
  const [viagens, setViagens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingViagem, setEditingViagem] = useState(null);
  const [showAddViagem, setShowAddViagem] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => {
    carregarViagens();
  }, []);

  const carregarViagens = async () => {
    try {
      const response = await axios.get(`${API}/viagens`, getAuthHeaders());
      setViagens(response.data);
    } catch (error) {
      toast.error('Erro ao carregar viagens');
    } finally {
      setLoading(false);
    }
  };

  const excluirViagem = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta viagem e todas as suas transações?')) {
      try {
        await axios.delete(`${API}/viagens/${id}`, getAuthHeaders());
        toast.success('Viagem excluída com sucesso');
        carregarViagens();
      } catch (error) {
        toast.error('Erro ao excluir viagem');
      }
    }
  };

  const filteredViagens = viagens.filter(viagem =>
    viagem.nome_viagem.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Gerenciar Viagens</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              data-testid="close-viagens-modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="flex justify-between items-center mb-4">
            <input
              type="text"
              placeholder="Buscar viagem..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flex-1 mr-4 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              data-testid="search-viagens-input"
            />
            
            <button
              onClick={() => setShowAddViagem(true)}
              className="px-4 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 flex items-center gap-2"
              data-testid="add-viagem-button"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Nova Viagem
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nome da Viagem</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Datas</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Orçamento</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ações</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredViagens.map((viagem) => {
                  const getStatusBadge = (status) => {
                    switch(status) {
                      case 'Concluída': return 'bg-green-100 text-green-700';
                      case 'Em andamento': return 'bg-blue-100 text-blue-700';
                      default: return 'bg-gray-100 text-gray-700';
                    }
                  };
                  
                  const formatDate = (dateStr) => {
                    if (!dateStr) return '-';
                    const date = new Date(dateStr + 'T00:00:00');
                    return date.toLocaleDateString('pt-BR');
                  };
                  
                  return (
                    <tr key={viagem.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <div>
                          <p className="text-sm font-medium text-gray-900">{viagem.nome_viagem}</p>
                          <p className="text-xs text-gray-500">
                            {[viagem.cidade, viagem.estado, viagem.pais].filter(Boolean).join(', ') || '-'}
                          </p>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-500">
                        {viagem.data_inicio && viagem.data_fim ? (
                          <span>{formatDate(viagem.data_inicio)} - {formatDate(viagem.data_fim)}</span>
                        ) : (
                          <span className="text-gray-400">Não definidas</span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <span className={`text-xs font-medium px-2 py-1 rounded-full ${getStatusBadge(viagem.status)}`}>
                          {viagem.status || 'Planejada'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-500">
                        R$ {viagem.orcamento.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </td>
                      <td className="px-4 py-3 text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => setEditingViagem(viagem)}
                            className="text-purple-600 hover:text-purple-900"
                            title="Editar"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          {viagem.status !== 'Concluída' && (
                            <button
                              onClick={() => excluirViagem(viagem.id)}
                              className="text-red-600 hover:text-red-900"
                              title="Excluir"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showAddViagem && (
        <AddViagemModal
          onClose={() => setShowAddViagem(false)}
          onSuccess={() => {
            setShowAddViagem(false);
            carregarViagens();
          }}
        />
      )}

      {editingViagem && (
        <EditViagemModal
          viagem={editingViagem}
          onClose={() => setEditingViagem(null)}
          onSuccess={() => {
            setEditingViagem(null);
            carregarViagens();
          }}
        />
      )}
    </div>
  );
}

// Modal para Adicionar Viagem
function AddViagemModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    cidade: '',
    estado: '',
    pais: '',
    orcamento: '',
    data_inicio: '',
    data_fim: ''
  });
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.cidade && !formData.estado && !formData.pais) {
      toast.error('Preencha pelo menos um campo: Cidade, Estado ou País');
      return;
    }
    
    setLoading(true);

    try {
      const payload = {
        cidade: formData.cidade || null,
        estado: formData.estado || null,
        pais: formData.pais || null,
        orcamento: parseFloat(formData.orcamento),
        data_inicio: formData.data_inicio || null,
        data_fim: formData.data_fim || null
      };

      await axios.post(`${API}/viagens`, payload, getAuthHeaders());
      toast.success('Viagem cadastrada com sucesso');
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao cadastrar viagem');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Nova Viagem</h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
              <input
                type="text"
                value={formData.cidade}
                onChange={(e) => setFormData({...formData, cidade: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="Ex: São Paulo"
                data-testid="viagem-cidade-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
              <input
                type="text"
                value={formData.estado}
                onChange={(e) => setFormData({...formData, estado: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="Ex: SP"
                data-testid="viagem-estado-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">País</label>
              <input
                type="text"
                value={formData.pais}
                onChange={(e) => setFormData({...formData, pais: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                placeholder="Ex: Brasil"
                data-testid="viagem-pais-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Orçamento (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.orcamento}
                onChange={(e) => setFormData({...formData, orcamento: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
                min="0"
                placeholder="0.00"
                data-testid="viagem-orcamento-input"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data Início</label>
                <input
                  type="date"
                  value={formData.data_inicio}
                  onChange={(e) => setFormData({...formData, data_inicio: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  data-testid="viagem-data-inicio-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data Fim</label>
                <input
                  type="date"
                  value={formData.data_fim}
                  onChange={(e) => setFormData({...formData, data_fim: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  data-testid="viagem-data-fim-input"
                />
              </div>
            </div>
            
            <p className="text-xs text-gray-500">
              As datas são opcionais, mas permitem calcular projeções de custo diário.
            </p>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                data-testid="viagem-cancel-button"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:from-purple-700 hover:to-purple-800 disabled:opacity-50"
                data-testid="viagem-save-button"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Editar Viagem
function EditViagemModal({ viagem, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    cidade: viagem.cidade || '',
    estado: viagem.estado || '',
    pais: viagem.pais || '',
    orcamento: viagem.orcamento,
    data_inicio: viagem.data_inicio || '',
    data_fim: viagem.data_fim || ''
  });
  const [loading, setLoading] = useState(false);
  const [concluding, setConcluding] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.cidade && !formData.estado && !formData.pais) {
      toast.error('Preencha pelo menos um campo: Cidade, Estado ou País');
      return;
    }
    
    setLoading(true);

    try {
      const payload = {
        cidade: formData.cidade || null,
        estado: formData.estado || null,
        pais: formData.pais || null,
        orcamento: parseFloat(formData.orcamento),
        data_inicio: formData.data_inicio || null,
        data_fim: formData.data_fim || null
      };

      await axios.put(`${API}/viagens/${viagem.id}`, payload, getAuthHeaders());
      toast.success('Viagem atualizada com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao atualizar viagem');
    } finally {
      setLoading(false);
    }
  };

  const handleConcluir = async () => {
    if (!window.confirm('Tem certeza que deseja concluir esta viagem? Após concluída, não será mais possível adicionar gastos.')) {
      return;
    }
    
    setConcluding(true);
    try {
      await axios.put(`${API}/viagens/${viagem.id}/concluir`, {}, getAuthHeaders());
      toast.success('Viagem concluída com sucesso!');
      onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao concluir viagem');
    } finally {
      setConcluding(false);
    }
  };

  const isViagemConcluida = viagem.status === 'Concluída';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-bold text-gray-900">Editar Viagem</h3>
            {viagem.status && (
              <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                viagem.status === 'Concluída' ? 'bg-green-100 text-green-700' :
                viagem.status === 'Em andamento' ? 'bg-blue-100 text-blue-700' :
                'bg-gray-100 text-gray-700'
              }`}>
                {viagem.status}
              </span>
            )}
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
              <input
                type="text"
                value={formData.cidade}
                onChange={(e) => setFormData({...formData, cidade: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                disabled={isViagemConcluida}
                data-testid="edit-viagem-cidade-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
              <input
                type="text"
                value={formData.estado}
                onChange={(e) => setFormData({...formData, estado: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                disabled={isViagemConcluida}
                data-testid="edit-viagem-estado-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">País</label>
              <input
                type="text"
                value={formData.pais}
                onChange={(e) => setFormData({...formData, pais: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                disabled={isViagemConcluida}
                data-testid="edit-viagem-pais-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Orçamento (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.orcamento}
                onChange={(e) => setFormData({...formData, orcamento: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
                min="0"
                disabled={isViagemConcluida}
                data-testid="edit-viagem-orcamento-input"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data Início</label>
                <input
                  type="date"
                  value={formData.data_inicio}
                  onChange={(e) => setFormData({...formData, data_inicio: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  disabled={isViagemConcluida}
                  data-testid="edit-viagem-data-inicio-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Data Fim</label>
                <input
                  type="date"
                  value={formData.data_fim}
                  onChange={(e) => setFormData({...formData, data_fim: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                  disabled={isViagemConcluida}
                  data-testid="edit-viagem-data-fim-input"
                />
              </div>
            </div>

            {!isViagemConcluida && (
              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  data-testid="edit-viagem-cancel-button"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleConcluir}
                  disabled={concluding}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
                  data-testid="edit-viagem-concluir-button"
                >
                  {concluding ? 'Concluindo...' : 'Concluir Viagem'}
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:from-purple-700 hover:to-purple-800 disabled:opacity-50"
                  data-testid="edit-viagem-save-button"
                >
                  {loading ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            )}
            
            {isViagemConcluida && (
              <div className="pt-4">
                <p className="text-sm text-gray-500 text-center mb-3">Esta viagem está concluída e não pode ser editada.</p>
                <button
                  type="button"
                  onClick={onClose}
                  className="w-full px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Fechar
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Nova Transação de Viagem
function NovaTransacaoViagemModal({ onClose, onSuccess }) {
  const [viagens, setViagens] = useState([]);
  const [formData, setFormData] = useState({
    viagem_id: '',
    nome_viagem: '',
    tipo_transacao: 'Aporte',
    valor: '',
    rendimento: '0',
    data: ''
  });
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => {
    carregarViagens();
  }, []);

  const carregarViagens = async () => {
    try {
      const response = await axios.get(`${API}/viagens`, getAuthHeaders());
      setViagens(response.data);
    } catch (error) {
      toast.error('Erro ao carregar viagens');
    }
  };

  const handleViagemChange = (viagemId) => {
    const viagem = viagens.find(v => v.id === viagemId);
    if (viagem) {
      setFormData({
        ...formData,
        viagem_id: viagemId,
        nome_viagem: viagem.nome_viagem
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        viagem_id: formData.viagem_id,
        nome_viagem: formData.nome_viagem,
        tipo_transacao: formData.tipo_transacao,
        valor: parseFloat(formData.valor),
        rendimento: parseFloat(formData.rendimento) || 0,
        data: formData.data
      };

      await axios.post(`${API}/viagens/transacoes`, payload, getAuthHeaders());
      toast.success('Transação criada com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao criar transação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Nova Transação</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Viagem</label>
              <select
                value={formData.viagem_id}
                onChange={(e) => handleViagemChange(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
              >
                <option value="">Selecione uma viagem</option>
                {viagens.map((viagem) => (
                  <option key={viagem.id} value={viagem.id}>
                    {viagem.nome_viagem}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tipo</label>
              <select
                value={formData.tipo_transacao}
                onChange={(e) => setFormData({...formData, tipo_transacao: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
              >
                <option value="Aporte">Aporte</option>
                <option value="Retirada">Retirada</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.valor}
                onChange={(e) => setFormData({...formData, valor: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
                min="0"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Rendimento (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.rendimento}
                onChange={(e) => setFormData({...formData, rendimento: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                min="0"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
              <input
                type="date"
                value={formData.data}
                onChange={(e) => setFormData({...formData, data: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                required
              />
            </div>

            <div className="flex justify-end space-x-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 disabled:opacity-50"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Nova Receita
function NovaReceitaModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    origem: '',
    valor: '',
    data: ''
  });
  const [loading, setLoading] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        origem: formData.origem,
        valor: parseFloat(formData.valor),
        data: formData.data
      };

      await axios.post(`${API}/financas/receitas`, payload, getAuthHeaders());
      toast.success('Receita cadastrada com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao cadastrar receita');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Nova Receita</h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Origem da Receita</label>
              <input
                type="text"
                value={formData.origem}
                onChange={(e) => setFormData({...formData, origem: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
                placeholder="Ex: Salário, Freelance"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.valor}
                onChange={(e) => setFormData({...formData, valor: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
                min="0"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
              <input
                type="date"
                value={formData.data}
                onChange={(e) => setFormData({...formData, data: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
              />
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg hover:from-green-700 hover:to-green-800 disabled:opacity-50"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Nova Despesa
function NovaDespesaModal({ onClose, onSuccess }) {
  const CATEGORIAS_FIXAS = [
    'Moradia',
    'Contas Domésticas Essenciais',
    'Despesas Domésticas',
    'Comunicações e Serviços',
    'Transporte',
    'Saúde',
    'Educação',
    'Financeiro',
    'Animais de Estimação',
    'Outros Custos Fixos'
  ];

  const [formData, setFormData] = useState({
    categoria: '',
    novaCategoria: '',
    subcategoria: '',
    valor: '',
    data: ''
  });
  const [loading, setLoading] = useState(false);
  const [mostrarNovaCategoria, setMostrarNovaCategoria] = useState(false);

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const categoriaFinal = mostrarNovaCategoria ? formData.novaCategoria : formData.categoria;
      
      const payload = {
        categoria: categoriaFinal,
        subcategoria: formData.subcategoria || null,
        valor: parseFloat(formData.valor),
        data: formData.data
      };

      await axios.post(`${API}/financas/despesas`, payload, getAuthHeaders());
      toast.success('Despesa cadastrada com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao cadastrar despesa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Nova Despesa</h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
              <select
                value={mostrarNovaCategoria ? 'nova' : formData.categoria}
                onChange={(e) => {
                  if (e.target.value === 'nova') {
                    setMostrarNovaCategoria(true);
                  } else {
                    setMostrarNovaCategoria(false);
                    setFormData({...formData, categoria: e.target.value});
                  }
                }}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required={!mostrarNovaCategoria}
              >
                <option value="">Selecione uma categoria</option>
                {CATEGORIAS_FIXAS.map((cat) => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
                <option value="nova">+ Nova Categoria</option>
              </select>
            </div>

            {mostrarNovaCategoria && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome da Nova Categoria</label>
                <input
                  type="text"
                  value={formData.novaCategoria}
                  onChange={(e) => setFormData({...formData, novaCategoria: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  required
                  placeholder="Digite o nome da categoria"
                />
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria (Opcional)</label>
              <input
                type="text"
                value={formData.subcategoria}
                onChange={(e) => setFormData({...formData, subcategoria: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Ex: Aluguel, Luz, Água"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.valor}
                onChange={(e) => setFormData({...formData, valor: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
                min="0"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
              <input
                type="date"
                value={formData.data}
                onChange={(e) => setFormData({...formData, data: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                required
              />
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-lg hover:from-red-700 hover:to-red-800 disabled:opacity-50"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
// Modal unificado para Nova Transação de Finanças Pessoais
function NovaTransacaoFinancasModal({ onClose, onSuccess }) {
  const [tipo, setTipo] = useState('receita'); // 'receita' ou 'despesa'
  const [formData, setFormData] = useState({
    origem: '',
    categoria: '',
    novaCategoria: '',
    subcategoria: '',
    valor: '',
    data: ''
  });
  const [loading, setLoading] = useState(false);
  const [mostrarNovaCategoria, setMostrarNovaCategoria] = useState(false);

  const CATEGORIAS_FIXAS = [
    'Moradia',
    'Contas Domésticas Essenciais',
    'Despesas Domésticas',
    'Comunicações e Serviços',
    'Transporte',
    'Saúde',
    'Educação',
    'Financeiro',
    'Animais de Estimação',
    'Outros Custos Fixos'
  ];

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (tipo === 'receita') {
        const payload = {
          origem: formData.origem,
          valor: parseFloat(formData.valor),
          data: formData.data
        };
        await axios.post(`${API}/financas/receitas`, payload, getAuthHeaders());
        toast.success('Receita cadastrada com sucesso');
      } else {
        const categoriaFinal = mostrarNovaCategoria ? formData.novaCategoria : formData.categoria;
        const payload = {
          categoria: categoriaFinal,
          subcategoria: formData.subcategoria || null,
          valor: parseFloat(formData.valor),
          data: formData.data
        };
        await axios.post(`${API}/financas/despesas`, payload, getAuthHeaders());
        toast.success('Despesa cadastrada com sucesso');
      }
      onSuccess();
    } catch (error) {
      toast.error('Erro ao cadastrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Nova Transação</h3>
          
          {/* Seletor de Tipo */}
          <div className="flex gap-2 mb-4">
            <button
              type="button"
              onClick={() => setTipo('receita')}
              className={`flex-1 py-2 rounded-lg font-medium transition-all ${
                tipo === 'receita' 
                  ? 'bg-green-600 text-white' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              💰 Receita
            </button>
            <button
              type="button"
              onClick={() => setTipo('despesa')}
              className={`flex-1 py-2 rounded-lg font-medium transition-all ${
                tipo === 'despesa' 
                  ? 'bg-red-600 text-white' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              💸 Despesa
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {tipo === 'receita' ? (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Origem da Receita</label>
                  <input
                    type="text"
                    value={formData.origem}
                    onChange={(e) => setFormData({...formData, origem: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                    placeholder="Ex: Salário, Freelance"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.valor}
                    onChange={(e) => setFormData({...formData, valor: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                    min="0"
                    placeholder="0.00"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                  <input
                    type="date"
                    value={formData.data}
                    onChange={(e) => setFormData({...formData, data: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
                  <select
                    value={mostrarNovaCategoria ? 'nova' : formData.categoria}
                    onChange={(e) => {
                      if (e.target.value === 'nova') {
                        setMostrarNovaCategoria(true);
                      } else {
                        setMostrarNovaCategoria(false);
                        setFormData({...formData, categoria: e.target.value});
                      }
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required={!mostrarNovaCategoria}
                  >
                    <option value="">Selecione uma categoria</option>
                    {CATEGORIAS_FIXAS.map((cat) => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                    <option value="nova">+ Nova Categoria</option>
                  </select>
                </div>

                {mostrarNovaCategoria && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nome da Nova Categoria</label>
                    <input
                      type="text"
                      value={formData.novaCategoria}
                      onChange={(e) => setFormData({...formData, novaCategoria: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                      required
                      placeholder="Digite o nome da categoria"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria (Opcional)</label>
                  <input
                    type="text"
                    value={formData.subcategoria}
                    onChange={(e) => setFormData({...formData, subcategoria: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    placeholder="Ex: Aluguel, Luz, Água"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.valor}
                    onChange={(e) => setFormData({...formData, valor: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required
                    min="0"
                    placeholder="0.00"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                  <input
                    type="date"
                    value={formData.data}
                    onChange={(e) => setFormData({...formData, data: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required
                  />
                </div>
              </>
            )}

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className={`px-6 py-2 rounded-lg text-white font-medium disabled:opacity-50 ${
                  tipo === 'receita' 
                    ? 'bg-green-600 hover:bg-green-700' 
                    : 'bg-red-600 hover:bg-red-700'
                }`}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Editar Transação de Finanças Pessoais
function EditarTransacaoFinancasModal({ transaction, onClose, onSuccess }) {
  const isReceita = transaction.origem !== undefined;
  const isDespesaMensal = transaction.ano !== undefined && transaction.mes !== undefined;
  const [formData, setFormData] = useState({
    origem: transaction.origem || '',
    categoria: transaction.categoria || '',
    subcategoria: transaction.subcategoria || '',
    valor: transaction.valor || '',
    data: transaction.data || '',
    ano: transaction.ano || new Date().getFullYear(),
    mes: transaction.mes || new Date().getMonth() + 1
  });
  const [loading, setLoading] = useState(false);

  const CATEGORIAS_FIXAS = [
    'Moradia',
    'Contas Domésticas Essenciais',
    'Despesas Domésticas',
    'Comunicações e Serviços',
    'Transporte',
    'Saúde',
    'Educação',
    'Financeiro',
    'Animais de Estimação',
    'Outros Custos Fixos'
  ];

  const MESES = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
  ];

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isReceita) {
        const payload = {
          origem: formData.origem,
          valor: parseFloat(formData.valor),
          data: formData.data
        };
        await axios.put(`${API}/financas/receitas/${transaction.id}`, payload, getAuthHeaders());
        toast.success('Receita atualizada com sucesso');
      } else if (isDespesaMensal) {
        const payload = {
          ano: parseInt(formData.ano),
          mes: parseInt(formData.mes),
          categoria: formData.categoria,
          subcategoria: formData.subcategoria || null,
          valor: parseFloat(formData.valor)
        };
        await axios.put(`${API}/financas/despesas-mensais/${transaction.id}`, payload, getAuthHeaders());
        toast.success('Despesa mensal atualizada com sucesso');
      } else {
        const payload = {
          categoria: formData.categoria,
          subcategoria: formData.subcategoria || null,
          valor: parseFloat(formData.valor),
          data: formData.data
        };
        await axios.put(`${API}/financas/despesas/${transaction.id}`, payload, getAuthHeaders());
        toast.success('Despesa atualizada com sucesso');
      }
      onSuccess();
    } catch (error) {
      toast.error('Erro ao atualizar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Editar {isReceita ? 'Receita' : isDespesaMensal ? 'Despesa Mensal' : 'Despesa'}
          </h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            {isReceita ? (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Origem da Receita</label>
                  <input
                    type="text"
                    value={formData.origem}
                    onChange={(e) => setFormData({...formData, origem: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.valor}
                    onChange={(e) => setFormData({...formData, valor: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                    min="0"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                  <input
                    type="date"
                    value={formData.data}
                    onChange={(e) => setFormData({...formData, data: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                    required
                  />
                </div>
              </>
            ) : isDespesaMensal ? (
              <>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ano</label>
                    <input
                      type="number"
                      value={formData.ano}
                      onChange={(e) => setFormData({...formData, ano: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      required
                      min="2000"
                      max="2100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mês</label>
                    <select
                      value={formData.mes}
                      onChange={(e) => setFormData({...formData, mes: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      required
                    >
                      {MESES.map((m) => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
                  <select
                    value={formData.categoria}
                    onChange={(e) => setFormData({...formData, categoria: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    required
                  >
                    <option value="">Selecione uma categoria</option>
                    {CATEGORIAS_FIXAS.map((cat) => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                    {!CATEGORIAS_FIXAS.includes(formData.categoria) && formData.categoria && (
                      <option value={formData.categoria}>{formData.categoria}</option>
                    )}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria (Opcional)</label>
                  <input
                    type="text"
                    value={formData.subcategoria}
                    onChange={(e) => setFormData({...formData, subcategoria: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.valor}
                    onChange={(e) => setFormData({...formData, valor: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                    required
                    min="0"
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
                  <select
                    value={formData.categoria}
                    onChange={(e) => setFormData({...formData, categoria: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required
                  >
                    <option value="">Selecione uma categoria</option>
                    {CATEGORIAS_FIXAS.map((cat) => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                    {!CATEGORIAS_FIXAS.includes(formData.categoria) && formData.categoria && (
                      <option value={formData.categoria}>{formData.categoria}</option>
                    )}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria (Opcional)</label>
                  <input
                    type="text"
                    value={formData.subcategoria}
                    onChange={(e) => setFormData({...formData, subcategoria: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.valor}
                    onChange={(e) => setFormData({...formData, valor: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required
                    min="0"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Data</label>
                  <input
                    type="date"
                    value={formData.data}
                    onChange={(e) => setFormData({...formData, data: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    required
                  />
                </div>
              </>
            )}

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className={`px-6 py-2 rounded-lg text-white font-medium disabled:opacity-50 ${
                  isReceita 
                    ? 'bg-green-600 hover:bg-green-700' 
                    : 'bg-red-600 hover:bg-red-700'
                }`}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Modal para Novo Gasto Mensal
function NovoGastoMensalModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    ano: new Date().getFullYear(),
    mes: new Date().getMonth() + 1,
    categoria: '',
    subcategoria: '',
    valor: ''
  });
  const [loading, setLoading] = useState(false);

  const MESES = [
    { valor: 1, nome: 'Janeiro' },
    { valor: 2, nome: 'Fevereiro' },
    { valor: 3, nome: 'Março' },
    { valor: 4, nome: 'Abril' },
    { valor: 5, nome: 'Maio' },
    { valor: 6, nome: 'Junho' },
    { valor: 7, nome: 'Julho' },
    { valor: 8, nome: 'Agosto' },
    { valor: 9, nome: 'Setembro' },
    { valor: 10, nome: 'Outubro' },
    { valor: 11, nome: 'Novembro' },
    { valor: 12, nome: 'Dezembro' }
  ];

  const CATEGORIAS_FIXAS = [
    'Moradia',
    'Contas Domésticas Essenciais',
    'Despesas Domésticas',
    'Comunicações e Serviços',
    'Transporte',
    'Saúde',
    'Educação',
    'Financeiro',
    'Animais de Estimação',
    'Outros Custos Fixos'
  ];

  const getAuthHeaders = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ano: parseInt(formData.ano),
        mes: parseInt(formData.mes),
        categoria: formData.categoria,
        subcategoria: formData.subcategoria || null,
        valor: parseFloat(formData.valor)
      };

      await axios.post(`${API}/financas/despesas-mensais`, payload, getAuthHeaders());
      toast.success('Gasto mensal cadastrado com sucesso');
      onSuccess();
    } catch (error) {
      toast.error('Erro ao cadastrar gasto mensal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Novo Gasto Mensal</h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ano</label>
                <input
                  type="number"
                  value={formData.ano}
                  onChange={(e) => setFormData({...formData, ano: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                  min="2000"
                  max="2100"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mês</label>
                <select
                  value={formData.mes}
                  onChange={(e) => setFormData({...formData, mes: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  required
                >
                  {MESES.map((mes) => (
                    <option key={mes.valor} value={mes.valor}>{mes.nome}</option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
              <select
                value={formData.categoria}
                onChange={(e) => setFormData({...formData, categoria: e.target.value, subcategoria: ''})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                required
              >
                <option value="">Selecione uma categoria</option>
                {CATEGORIAS_FIXAS.map((cat) => (
                  <option key={cat} value={cat}>{cat}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Subcategoria (Opcional)</label>
              <input
                type="text"
                value={formData.subcategoria}
                onChange={(e) => setFormData({...formData, subcategoria: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                placeholder="Ex: Aluguel, Luz, Internet"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Valor (R$)</label>
              <input
                type="number"
                step="0.01"
                value={formData.valor}
                onChange={(e) => setFormData({...formData, valor: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                required
                min="0"
                placeholder="0.00"
              />
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-medium disabled:opacity-50"
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
